import {
  AI_TRANSLATION_URL,
  ALL_STORE_SALES,
  APPROVAL_MARKETING_AI_ANALYSIS,
  APPROVAL_MARKETING_AI_PARAMETERS,
  APPROVAL_MARKETING_AI_SUMMARY,
  APPROVAL_INTERIOR_COST_ADEQUACY,
  APPROVAL_INTERIOR_SETTLEMENT,
  APPROVAL_MARKETING_ANALYSIS,
  AUTH_SHOP_ID_URL,
  BASE_CALENDAR_URL,
  BASE_TALK_FLOW_URL,
  BEST_SHOP_URL,
  BIRTHDAY_API_URL,
  BOARD_BASE_API_URL,
  BOARD_COMMENTS_API_URL,
  BOARD_FILTER_URL,
  BOARD_LIKES_API_URL,
  BOOK_PERIOD_URL,
  BRAND_PERMISSION_MISSING_URL,
  CALENDAR_LIST_URL,
  CHANGE_JOB_DESCRIPTION_URL,
  CHANGE_LANGUAGE_URL,
  CHANGE_PASSWORD_URL,
  CHECK_NICKNAME_URL,
  CONGESTION_URL,
  CONTENT_BANNER_LIST,
  CREATE_BOARD_URL,
  DELETE_PASSPORT_URL,
  EMAIL_LIST_URL,
  EMAIL_SIGNATURE_URL,
  EVENT_BANNER_LIST,
  FAQ_MESSAGE_URL,
  FAQ_SESSION_URL,
  FILE_DOWNLOAD_URL,
  FILE_UPLOAD_URL,
  FIND_USER_BASE_URL,
  FUTUBE_INFO,
  GET_ACTIVATED_TOKEN_URL,
  GET_AUTH_SHOP_INFO_URL,
  GET_CERTIFY_CODE_URL,
  I_READ_BOARD_URL,
  IMPORTANT_BOARD_URL,
  ITEM_SALES_DETAIL_URL,
  JOB_LIST_URL,
  LINK_LIST_URL,
  LOGIN_BY_AZURE_URL,
  LOGIN_BY_ISSUE_PORTAL_TOKEN_URL,
  MARKETING_BUDGET,
  MARKETING_PARTNER,
  MENU_URL,
  MESSAGE_ALL_READ_URL,
  MESSAGE_READ_URL,
  MY_BOOK_URL,
  MY_NOTIFICATION_OPTION_LIST_URL,
  MY_NOTIFICATION_OPTION_URL,
  MY_NOTIFICATION_PORTAL_OPTION_LIST_URL,
  NEW_BOOK_URL,
  NOTIFICATION_HISTORY_URL,
  NOTIFICATION_TOPICS_URL,
  ORGANIZATION_BASE_URL,
  ORGANIZATION_PASSPORT_URL,
  ORGANIZATION_URL,
  PASSPORT_BASE_URL,
  PASSPORT_SEARCH_URL,
  PATCH_PASSPORT_URL,
  PING_URL,
  POPUP_DISMISSAL,
  POPUP_LIST,
  PORTAL_PASSPORT_URL,
  PRODUCT_DETAIL_URL,
  PRODUCT_SALES_BY_COLORS_URL,
  PROOF_EMP_HISTORY_URL,
  QR_NUM_URL,
  RIVAL_RANK_STANDARD_COMPANY_URL,
  RIVAL_RANK_STORE_URL,
  RIVAL_RANK_URL,
  SALES_ANALYSIS_URL,
  SALES_BY_BEST_V2_URL,
  SALES_BY_CHANNEL_URL,
  SALES_BY_Item_URL,
  SALES_BY_SEASON_URL,
  SALES_BY_TYPE_URL,
  SALES_MAIN_URL,
  SALES_MAIN_URL_V2,
  SALES_COMPARE_DATE_URL,
  SALES_URL,
  SEARCH_EMP_HISTORY_URL,
  SEARCH_GPT_EMPLOYEE_URL,
  SEARCH_PASSPORT_URL,
  MENTION_CANDIDATES_URL,
  SEARCH_POINT_URL,
  SEASONS_URL,
  SEASONS_V2_URL,
  CATEGORY_SEASON_URL,
  SEASON_BASIS_PARAM,
  SEND_EMAIL_URL,
  SET_TOKEN_URL,
  SHOP_INFO_URL,
  SIGNATURE_URL,
  TELECOM_SUPPORT_DOCUMENT_REVIEW_URL,
  TELECOM_SUPPORT_SUBMIT_URL,
  UPDATE_COMMENT_LIKE_URL,
  UPDATE_LIKES_URL,
  UPDATE_NICKNAME_URL,
  VERIFY_CERTIFY_CODE_URL,
} from '@/constant/apiList';
import { buildQueryParams } from '@/utils';
import useSWR, { SWRConfiguration } from 'swr';
import {
  ApiTokenType,
  BestItemTypeV2,
  Board,
  BoardContent,
  BoardContentData,
  BoardLikes,
  BoardListItem,
  BookPeriod,
  BrandMetaData,
  BrandSaleBase,
  BrandSales,
  BrandSummaryResponse,
  CalendarId,
  CategoryFilter,
  CategoryType,
  ChannelInfo,
  Congestion,
  CreateBoardData,
  CreateTalkFlowParams,
  Dday,
  DocumentFavoriteFilter,
  DocumentListParams,
  DownLoadResponse,
  EmployeeQuickSearch,
  EmpProofHistoryData,
  FavoriteFilterData,
  GetComments,
  GptResponse,
  IBirthdayObj,
  ItemDetail,
  ItemDetailParams,
  ItemDetailRow,
  ItemImageList,
  ItemInfo,
  ItemParams,
  ItemSalesByStoreRanking,
  LinkFilterList,
  MenuResponse,
  MyBookData,
  MyInfo,
  MyJob,
  NewBookData,
  NewShopDetailData,
  NlResponse,
  Notification,
  NotiHistoryData,
  NotiToken,
  NotiTopic,
  NotiWithMeta,
  Organizations,
  OverTimeHistory,
  Pagination,
  Passport,
  PassportSearchParams,
  Period,
  PhoneBillResponse,
  PhoneBillStatus,
  PortalLoginType,
  PortalToken,
  PortalUserResponse,
  ProductCategory,
  ProductSubCategory,
  ProfileResponse,
  ReadData,
  RecordDetail,
  Recording,
  RecordListType,
  RivalCompanyStandardResponse,
  RivalRankResponse,
  RivalStoreResponse,
  SaleByColorData,
  SalesBrandStoresParams,
  SalesByStoreRanking,
  SalesDetail,
  SalesMain,
  SalesMainParams,
  SalesCompareDate,
  SalesParams,
  SalesTypeResponse,
  SearchJobList,
  SearchResponse,
  CategorySeasonBreakdown,
  CategorySeasonParams,
  Season,
  SeasonBasis,
  SeasonV2,
  SeasonInfo,
  SendMailData,
  ShareModeParam,
  ShopGroup,
  ShopInfo,
  ShopInfoParams,
  StoreFilter,
  StoreListParams,
  SummarizeParams,
  TalkFlowChatMessage,
  TalkFlowChatSendRequest,
  TalkFlowChatSendResponse,
  TalkFlowChatSession,
  TalkFlowShare,
  TalkFlowFilterRecommendPerson,
  TimeAdjustmentSummary,
  TokenInfo,
  LeaveCancelType,
  LeaveDuration,
  Translation,
  UploadResponse,
  User,
  UserV0,
  VacationStatus,
  Weather,
} from '@/types/api';
import {
  appFetchConfig,
  deleteDataFetcher,
  getDataFetcher,
  getNestedDataFetcher,
  getNestedMetaDataFetcher,
  getNestedNotificationDataFetcher,
  getSocialDataNestedDataFetcherWithMeta,
  makeQueryString,
  patchDataFetcher,
  postDataFetcher,
  putDataFetcher,
} from '@/utils/apis';
import { fetchApi } from '@/utils/api/customAxios';
import process from 'process';
import { Futube, Meta } from '@/types/legacyApi';
import useSWRInfinite from 'swr/infinite';
import { getCookie } from '@/utils/tokens';
import { COOKIE_KEY_ACCESS_TOKEN } from '@/constant/keys';
import { msInstance } from '@/utils/api/msAzure/instance';
import { BoardDeployStatusResponse, BoardDetailData } from '@/types/board';
import { BoardFormData } from '@/hooks/board/useBoardForm';
import { queryBuilder } from '@/utils/urls';
import { boardDetailDataToBoardFormData } from '@/utils/board';
import { useEffect, useMemo, useState } from 'react';
import { apiURL } from '@/constant/apiURL';
import { isFnCo } from '@/utils/passport';
import { isAxiosError } from 'axios';
import { PasswordForm } from '@/hooks/form/usePasswordForm';
import { SmsVerification } from '@/hooks/form/useSmsVerificationForm';
import dayjs from 'dayjs';
import { RemoteFile } from '@/components/file-thumbnail/utils';
import { EventCategoryIds } from '@/components/SideCategory';
import { CalendarEvent } from '@/components/Home/HomeSNB/SNBCalendar/types';
import {
  AIMarketingBudgetData,
  AIMarketingParameterData,
  AnalysisApprovalParams,
  AnalysisApprovalResult,
  AnalysisParams,
  AnalysisResult,
  SummaryParams,
  SummaryResult,
  VenderListItem,
  venderType,
} from '@/components/AIMarketingExpense/types';
import type {
  InteriorCostAdequacyParams,
  InteriorCostAdequacyResult,
} from '@/types/interior';
import useSWRImmutable from 'swr/immutable';
import { toFiniteNumber } from '@/utils/formatNumber';
import { BoardDetailCommentProps } from '@/components/Board/BoardDetail/Feedback/BoardDetailComment';
import { formatDayjsToDateString } from '@/utils/format';
import { normalizeAppLanguage } from '@/utils/language';
import { ApiLanguageCode } from '@/utils/language';
import { TalkFlowAISummary } from '@/types/talk_flow';
import {
  ContentBanner,
  ContentBannerArea,
  EventBanner,
  EventBannerDisplayDevice,
} from '@/types/event';
import usePlatform from '@/components/Record/hooks/usePlatform';

/** 이벤트 배너 재조회 주기(ms). 노출 시작/종료가 새로고침 없이 반영되도록 한다. */
const EVENT_BANNER_REFRESH_INTERVAL = 60 * 1000;

export const swrConfig: SWRConfiguration = {
  onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
    // Never retry on 404.
    if (error?.response?.status === 404) return;
    if (error?.response?.status === 400) return;
    // Only retry up to 10 times.
    if (retryCount >= 3) return;
    // Retry after 5 seconds.
    setTimeout(() => revalidate({ retryCount }), 5000);
  },
};

export type ListParams = {
  listSize?: number;
  currentPage?: number;
  orderType?: 'desc' | 'asc';
  sortType?: 'createdAt' | 'updatedAt';
};

export type BoardSearchParams = {
  listSize: number;
  currentPage: number;
  sortType: string;
  orderType: 'desc' | 'acs';
  boardNos: string;
  documentNo: string;
  category: string;
  dDay: string;
};

export type BoardParams = Pick<BoardSearchParams, 'documentNo' | 'category'> & {
  boardNo: string;
};

export const useBoard = (obj: BoardParams, shouldFetch = true) => {
  const params = new URLSearchParams(obj);
  return useSWR<BoardContent>(
    shouldFetch ? `${BOARD_BASE_API_URL}?${params.toString()}` : null,
    getNestedDataFetcher<BoardContent>,
    {
      shouldRetryOnError: false,
    },
  );
};

export const useBoardLikes = (
  obj: Pick<BoardParams, 'boardNo' | 'documentNo'>,
) => {
  const params = new URLSearchParams(obj);
  return useSWR<BoardLikes>(
    `${BOARD_BASE_API_URL}${BOARD_LIKES_API_URL}?${params.toString()}`,
    getNestedDataFetcher<BoardLikes>,
    swrConfig,
  );
};

export const useFindUser = (userId: string, shouldFetch = true) => {
  return useSWR<UserV0>(
    shouldFetch ? `${FIND_USER_BASE_URL}${userId}` : null,
    getNestedDataFetcher<UserV0>,
    swrConfig,
  );
};

export const useUpdateLikes = (
  obj: Pick<BoardParams, 'boardNo' | 'documentNo'>,
) => {
  return postDataFetcher(UPDATE_LIKES_URL, obj);
};

export const useComments = (
  obj: Pick<BoardParams, 'boardNo' | 'documentNo'>,
) => {
  const params = new URLSearchParams(obj);
  return useSWR<GetComments>(
    `${BOARD_BASE_API_URL}${BOARD_COMMENTS_API_URL}?${params.toString()}`,
    getNestedDataFetcher<GetComments>,
    swrConfig,
  );
};

export const useUpdateCommentLike = (obj: { snsKey: number }) => {
  return postDataFetcher(UPDATE_COMMENT_LIKE_URL, obj);
};

export const useLoginByAzure = (accessToken?: string) => {
  return fetchApi<{ data: TokenInfo }>({
    method: 'POST',
    url: LOGIN_BY_AZURE_URL,
    data: {
      accessToken: accessToken,
    },
  });
};

export const usePortalLogin = (params: PortalLoginType) => {
  return postDataFetcher<PortalLoginType, PortalToken>(
    LOGIN_BY_ISSUE_PORTAL_TOKEN_URL,
    params,
  );
};

type LinkCategory = 'link' | 'club' | 'office365' | 'powerBi' | 'guide';

export const useLinkList = (category: LinkCategory) => {
  return useSWR<LinkFilterList>(
    `${LINK_LIST_URL}?category=${category}&service=portal&sortType=sortNo&displayed=1`,
    getNestedDataFetcher<LinkFilterList>,
    swrConfig,
  );
};

export type FetchMentionOptions = {
  signal?: AbortSignal;
  currentPage?: number;
};
const MENTION_PAGE_SIZE = 20;
export type MentionCandidate = {
  passportId: string;
  name: string;
  nickname: string | null;
  positionName: string;
  companyName: string;
  divisionName: string;
  departmentName: string;
  profileImageUrl: string;
};
export const fetchMentionSuggestions = async (
  keyword: string,
  options?: FetchMentionOptions,
) => {
  // meta 는 서버 페이지네이션 적용 전 응답에는 없다.
  return await getNestedMetaDataFetcher<{
    meta?: Meta;
    data: MentionCandidate[];
  }>(
    `${MENTION_CANDIDATES_URL}${queryBuilder(
      {
        keyword,
        currentPage: options?.currentPage ?? 1,
        listSize: MENTION_PAGE_SIZE,
        // 서버 페이지네이션 적용 전에는 listSize 를 몰라 limit 으로 크기를 받는다. 서버 적용 후 제거.
        limit: MENTION_PAGE_SIZE,
      },
      { includeQuestionMark: true },
    )}`,
    undefined, // instance 생략
    undefined, // tokenType 생략
    undefined, // extraHeaders 생략
    options?.signal, // signal 전달
  );
};

/**
 * 인물검색 노출 설정 쿼리.
 *
 * 서버는 노출 파라미터를 생략하면 기본값(searchVisibility=true)을 적용하므로, 화면 성격에 맞는
 * 값을 항상 명시한다. 빈 값(`orgChartVisibility=`)은 "그 조건으로 거르지 않음" 을 뜻한다.
 *
 * - PORTAL: 포탈 공통 노출 설정(searchVisibility) 기준. 홈/조직도/회의록/소셜 등 대부분의 화면.
 * - APPROVAL: 전자결재 전용 노출 설정(approvalSearchVisibility) 기준. 파견직처럼 포탈 공통
 *   노출은 꺼져 있지만 전자결재에서는 검색돼야 하는 프로필을 위해 별도로 둔다. searchVisibility 를
 *   함께 보내면 서버가 두 조건을 모두 적용해 파견직이 다시 걸러지므로 절대 같이 보내지 않는다.
 *   (PORTAL-13956 / PORTAL-14029)
 * - ORGANIZATION: 조직도 노출 설정(orgChartVisibility) 기준.
 * - NONE: 노출 설정으로 거르지 않음.
 */
const PASSPORT_VISIBILITY_QUERY = {
  PORTAL: '&searchVisibility=true&orgChartVisibility=',
  APPROVAL: '&approvalSearchVisibility=true&orgChartVisibility=',
  ORGANIZATION: '&searchVisibility=&orgChartVisibility=true',
  NONE: '&searchVisibility=&orgChartVisibility=',
} as const;

type PassportVisibilityQuery =
  (typeof PASSPORT_VISIBILITY_QUERY)[keyof typeof PASSPORT_VISIBILITY_QUERY];

const usePassportSearchByVisibility = (
  visibilityQuery: PassportVisibilityQuery,
  payload: PassportSearchParams,
  minimumSearchLength: number,
  config?: SWRConfiguration,
) => {
  const { listSize = 1000, keyword = '', ...otherOptions } = payload;
  const trimmedKeyword = keyword.trim();

  return useSWR<SearchResponse>(
    () =>
      trimmedKeyword.length < minimumSearchLength
        ? null
        : `${SEARCH_PASSPORT_URL}${queryBuilder(
            {
              keyword: trimmedKeyword,
              listSize,
              issuerName: 'mainErp',
              ...otherOptions,
            },
            { includeQuestionMark: true },
          )}${visibilityQuery}`,
    getNestedMetaDataFetcher<SearchResponse>,
    config,
  );
};

/** 포탈 공통 인물검색 — 노출 설정(searchVisibility) 기준. */
export const usePassportSearch = (
  payload: PassportSearchParams,
  minimumSearchLength = 1,
  config?: SWRConfiguration,
) =>
  usePassportSearchByVisibility(
    PASSPORT_VISIBILITY_QUERY.PORTAL,
    payload,
    minimumSearchLength,
    config,
  );

/**
 * 전자결재 전용 인물검색 — 전자결재 노출 설정(approvalSearchVisibility) 기준.
 *
 * 재직 여부는 화면마다 다르므로 호출부에서 정한다.
 * - 목록(조회 조건): 퇴사자가 작성·결재한 문서도 찾을 수 있어야 해서 activated 를 빈 값으로 넘긴다.
 *   (생략하면 서버가 재직자만 반환한다 — 빈 값이어야 재직 필터가 풀린다)
 * - 상신 시 결재자·참조자 지정: 재직자만 대상이므로 `activated: 1` 을 함께 넘긴다.
 */
export const useApprovalPassportSearch = (
  payload: PassportSearchParams,
  minimumSearchLength = 1,
  config?: SWRConfiguration,
) =>
  usePassportSearchByVisibility(
    PASSPORT_VISIBILITY_QUERY.APPROVAL,
    payload,
    minimumSearchLength,
    config,
  );

/**
 * 회의록 작성자·내부 참석자 필터 인물검색.
 *
 * 퇴사자가 작성·참석한 회의록도 찾을 수 있어야 해서 재직자와 퇴사자를 나눠 조회한 뒤 합친다.
 * - 재직자: 포탈 공통 노출 설정(searchVisibility) 기준
 * - 퇴사자: 노출 설정과 무관하게 전부. 퇴사자는 searchVisibility=false 인 경우가 많아 PORTAL 기준이면 빠진다.
 * 서버는 "재직자에게만 노출 조건 적용" 을 한 번에 거를 수 없다.
 */
export const useRecordFilterPassportSearch = (
  payload: Omit<PassportSearchParams, 'activated'>,
  minimumSearchLength = 1,
) => {
  const active = usePassportSearchByVisibility(
    PASSPORT_VISIBILITY_QUERY.PORTAL,
    { ...payload, activated: 1 },
    minimumSearchLength,
  );
  const resigned = usePassportSearchByVisibility(
    PASSPORT_VISIBILITY_QUERY.NONE,
    { ...payload, activated: 0 },
    minimumSearchLength,
  );

  const data = useMemo<Pick<SearchResponse, 'data'> | undefined>(() => {
    if (active.isLoading || resigned.isLoading) return undefined;
    if (!active.data && !resigned.data) return undefined;
    return {
      data: [...(active.data?.data ?? []), ...(resigned.data?.data ?? [])],
    };
  }, [active.data, active.isLoading, resigned.data, resigned.isLoading]);

  return { data };
};

/** 조직도 인물검색 — 조직도 노출 설정(orgChartVisibility) 기준. */
export const usePassportSearchOrganization = (
  payload: PassportSearchParams,
  minimumSearchLength = 1,
  config?: SWRConfiguration,
) =>
  usePassportSearchByVisibility(
    PASSPORT_VISIBILITY_QUERY.ORGANIZATION,
    payload,
    minimumSearchLength,
    config,
  );

export const fetchSearchPassport = async (obj: PassportSearchParams) => {
  if (!obj) return [];

  return await getNestedDataFetcher<Passport[]>(
    `${SEARCH_PASSPORT_URL}?${queryBuilder({ issuerName: 'mainErp', ...obj })}`,
  );
};

export const DefaultOrganization =
  'detail.isLeader,desc,detail.isActingTeamLeader,desc,detail.isPartLeader,desc,' +
  'detail.positionCode,asc,detail.monthsInPosition,desc,detail.overallCareerMonths,desc,' +
  'detail.divisionName.ko,asc,detail.departmentName,asc,detail.name.ko,asc,detail.email,asc';

export const useFindPassport = (passportId: string) => {
  return useSWR<Passport>(
    passportId ? `${PASSPORT_BASE_URL}/${passportId}` : null,
    getNestedDataFetcher<Passport>,
    swrConfig,
  );
};

export type BoardFilterParams = BoardSearchParams & {
  mainBannerType: 'Y' | 'R' | 'N';
  title: string;
  userId: string;
  userName: string;
  companyCode: string;
  displayed: number;
};

export const useFilterBoard = (
  obj: Pick<
    BoardFilterParams,
    'listSize' | 'currentPage' | 'mainBannerType' | 'companyCode'
  >,
  fallback?: Board[],
) => {
  const queryParams = `${BOARD_FILTER_URL}?listSize=${obj.listSize}&currentPage=${obj.currentPage}&mainBannerType=${obj.mainBannerType}`;
  const companyCodeQueryParam = isFnCo(obj.companyCode)
    ? `&companyCode=${obj.companyCode}`
    : '';

  return useSWR<Board[]>(
    queryParams + companyCodeQueryParam,
    getNestedDataFetcher<Board[]>,
    { fallbackData: fallback },
  );
};

export const useImportantBoard = () => {
  return useSWR<Board[]>(IMPORTANT_BOARD_URL, getNestedDataFetcher);
};

export const useMyBook = () => {
  return useSWR<MyBookData[]>(MY_BOOK_URL, getNestedDataFetcher);
};

export const useEmployeeSearchHistory = () => {
  return useSWR<EmployeeQuickSearch[]>(
    SEARCH_EMP_HISTORY_URL,
    getNestedDataFetcher<EmployeeQuickSearch[]>,
    swrConfig,
  );
};

export const useDeleteSearchHistory = () => {
  return deleteDataFetcher(DELETE_PASSPORT_URL);
};

export const useDeleteSearchEmployee = (passportId: string) => {
  return deleteDataFetcher(`${DELETE_PASSPORT_URL}/${passportId}`);
};

export type SaveSearchParams = {
  name: string;
  userId: string;
  positionNameKor: string;
  organizationShortName: string;
  profileImageUrl: string;
};

export const useSaveEmployeeSearchHistory = (obj: EmployeeQuickSearch) => {
  return postDataFetcher(SEARCH_EMP_HISTORY_URL, obj);
};

export const useUpdateNickName = (obj: { nickname: string }) => {
  return patchDataFetcher(UPDATE_NICKNAME_URL, obj);
};

export const useSearchPoint = (userNo: string) => {
  return useSWR<{ employeePoint: number }>(
    `${SEARCH_POINT_URL}/${userNo}`,
    getNestedDataFetcher,
    swrConfig,
  );
};

export type SignatureData = {
  companyAddress: string;
  companyLogoImageUrl: string;
  displayOrganizationShortName: string;
  email: string;
  homePageUrl: string;
  insidePhone: string;
  mobilePhone: string;
  name: string;
  nickName: string;
};
export const useSignatureData = (userNo: string) => {
  return useSWR<SignatureData>(
    userNo ? `${SIGNATURE_URL}/${userNo}` : null,
    getNestedDataFetcher,
    swrConfig,
  );
};

type I18NData = {
  ko: string;
  en: string;
  zh: string;
};
export type EMailSignatureData = {
  name: I18NData;
  job: string;
  companyName: I18NData;
  divisionName: I18NData;
  positionName: I18NData;
  departmentName: string;
  companyAddress: string;
  nickname: string;
  phoneNumber: string;
  email: string;
  homepageUrl: string;
  logoUrl: string;
  insidePhone?: string;
};

export const useEmailSignatureData = () => {
  return useSWR<EMailSignatureData>(
    EMAIL_SIGNATURE_URL,
    getNestedDataFetcher,
    swrConfig,
  );
};

export const useChangePassWord = (obj: PasswordForm) => {
  return postDataFetcher(CHANGE_PASSWORD_URL, obj);
};

type CertifyCodeOption = {
  telephoneNumber: string;
  serviceName: string;
};
export const useGetCertifyCode = (mobileNumber: string) => {
  return postDataFetcher<
    CertifyCodeOption,
    { data: { smsVerificationId: string } }
  >(GET_CERTIFY_CODE_URL, {
    telephoneNumber: mobileNumber,
    serviceName: 'employmentVerification',
  });
};

export type CertifyForm = {
  smsVerificationId: string;
  smsVerificationCode: string;
};

export const useCertifySmsCode = (obj: CertifyForm) => {
  return postDataFetcher(`${VERIFY_CERTIFY_CODE_URL}`, obj);
};

export type PrintParams = {
  passportId: string;
  outputReason: string;
  smsVerificationId: string;
  smsVerificationCode: string;
};

export const usePrintEmpProof = (obj: PrintParams) => {
  return fetchApi<{ data: string }>({
    method: 'GET',
    url: `/api/v1/passport/me/certificate-employment/pdf?outputReason=${obj.outputReason}&smsVerificationId=${obj.smsVerificationId}&smsVerificationCode=${obj.smsVerificationCode}`,
  }).then((res) => res.data);
};

export type EmpProofHistoryParams = {
  employeeNumber: string;
  listSize: number;
  currentPage: number;
};

export const useHistoryEmpProof = (obj: EmpProofHistoryParams) => {
  const startDate = formatDayjsToDateString(dayjs().subtract(3, 'year'));
  return useSWR<EmpProofHistoryData[]>(
    `${PROOF_EMP_HISTORY_URL}?employeeNumber=${obj.employeeNumber}&listSize=${obj.listSize}&currentPage=${obj.currentPage}&startDate=${startDate}`,
    getNestedDataFetcher,
    swrConfig,
  );
};

export type AuthShopId = {
  onlineMallId: string;
  onlineMallPassword: string;
  employeeNumber: string;
};

export const useAuthShopId = (obj: AuthShopId) => {
  return postDataFetcher(AUTH_SHOP_ID_URL, obj);
};

export const useShopAuthInfo = (employeeNumber: string) => {
  return useSWR<{ customerId: string }>(
    `${GET_AUTH_SHOP_INFO_URL}/${employeeNumber}`,
    getNestedDataFetcher,
    swrConfig,
  );
};

export const useCreateBoard = () => {
  return useSWR<CreateBoardData[]>(
    CREATE_BOARD_URL,
    getNestedDataFetcher,
    swrConfig,
  );
};

export const useSendMail = (obj: SendMailData) => {
  return postDataFetcher(SEND_EMAIL_URL, obj);
};

// 현재 날짜안에 등록 기간인 도서 신청 데이터
export const useGetRequestBookData = () => {
  return useSWR<BookPeriod>(BOOK_PERIOD_URL, getNestedDataFetcher, swrConfig);
};

export const useReadBoard = (obj: ReadData) => {
  return postDataFetcher(I_READ_BOARD_URL, obj);
};

export const useNotiHistory = (listSize = 10) => {
  return useSWR<NotiWithMeta>(
    `${NOTIFICATION_HISTORY_URL}?listSize=${listSize}`,
    (url: string) =>
      fetchApi<NotiWithMeta>({
        method: 'GET',
        url,
        baseURL: process.env.NEXT_PUBLIC_NOTIFICATION_URL,
      }).then((res) => res),
  );
};

export const useNotiHistoryPagination = (size = 10) => {
  return useSWRInfinite<NotiHistoryData[]>(
    (page: number) =>
      `${NOTIFICATION_HISTORY_URL}?listSize=${size}&currentPage=${page + 1}`,
    getNestedNotificationDataFetcher<NotiHistoryData[]>,
  );
};

export const useNotiTopics = (listSize = 10) => {
  return useSWR<NotiTopic[]>(
    `${NOTIFICATION_TOPICS_URL}?listSize=${listSize}`,
    getNestedNotificationDataFetcher<NotiTopic[]>,
    {
      revalidateOnFocus: false,
      refreshInterval: 0,
      errorRetryCount: 0,
    },
  );
};

export const useNotiTokens = (listSize = 10) => {
  return useSWR<NotiToken[]>(
    `${GET_ACTIVATED_TOKEN_URL}?listSize=${listSize}`,
    getNestedNotificationDataFetcher<NotiToken[]>,
    {
      revalidateOnFocus: false,
      refreshInterval: 0,
      errorRetryCount: 0,
    },
  );
};

export const useFutubeInfo = () =>
  useSWR<Futube>(FUTUBE_INFO, getNestedDataFetcher);

export const useSetToken = (token: string) => {
  return fetchApi({
    method: 'POST',
    url: SET_TOKEN_URL,
    baseURL: process.env.NEXT_PUBLIC_NOTIFICATION_URL,
    data: {
      token: token,
      os: 'web',
      agent: navigator.userAgent,
      tokenKind: 'firebase',
      serviceName: 'portal',
    },
  }).catch((e) => {
    if (e?.response?.status === 400) return;
    return e;
  });
};

export const updateProfileImage = ({ id, obj }: { id: string; obj: File }) => {
  return fetchApi<{ data: ProfileResponse }>({
    extraHeaders: {
      'Content-Type': 'multipart/form-data',
    },
    method: 'POST',
    url: `${PASSPORT_BASE_URL}/${id}/profile-image`,
    data: {
      file: obj,
    },
  });
};

export const checkNickname = (nickname: string) => {
  return fetchApi({
    method: 'POST',
    url: `${CHECK_NICKNAME_URL}`,
    data: {
      nickname,
    },
  });
};

export const updateNickname = (id: string, nickname: string) => {
  return fetchApi({
    method: 'PATCH',
    url: UPDATE_NICKNAME_URL,
    data: {
      nickname,
    },
  });
};

export const useMessageAllRead = () => {
  return fetchApi({
    method: 'PATCH',
    url: MESSAGE_ALL_READ_URL,
    baseURL: process.env.NEXT_PUBLIC_NOTIFICATION_URL,
  });
};

export const useMessageRead = (id: string) => {
  return fetchApi({
    method: 'PATCH',
    url: `${MESSAGE_READ_URL}/${id}`,
    baseURL: process.env.NEXT_PUBLIC_NOTIFICATION_URL,
  });
};

export const useMenu = (myInfo?: MyInfo) => {
  return useSWR<MenuResponse>(
    myInfo?.companyCode
      ? `${MENU_URL}?type=global_navigation_bar&service=portal&companyCode=${myInfo.companyCode}`
      : null,
    getNestedDataFetcher,
    swrConfig,
  );
};

export const useMobileMenu = (myInfo?: MyInfo) => {
  return useSWR<MenuResponse>(
    myInfo?.companyCode
      ? `${MENU_URL}?type=global_navigation_bar&service=portal_mobile&companyCode=${myInfo.companyCode}`
      : null,
    getNestedDataFetcher,
    swrConfig,
  );
};

export const usePassport = () => {
  return useSWR<PortalUserResponse>(
    PORTAL_PASSPORT_URL,
    (key) =>
      fetchApi<{ data: PortalUserResponse }>({
        method: 'GET',
        url: key,
        extraHeaders: {
          Authorization: `Bearer ${getCookie(COOKIE_KEY_ACCESS_TOKEN)}`,
        },
      }).then((res) => {
        if (res.data.assignedPassports.length > 1) {
          // 법인명 가나다순
          res.data.assignedPassports.sort((a, b) =>
            a.detail.companyName.localeCompare(b.detail.companyName, 'ko'),
          );
        }
        return res.data;
      }),
    swrConfig,
  );
};

export const useGetOvertimeHistory = (startDate: string, endDate: string) => {
  return useSWR<OverTimeHistory>(
    startDate && endDate
      ? `/api/v1/passport/me/overtime?startDate=${startDate}&endDate=${endDate}`
      : null,
    getNestedDataFetcher,
  );
};

export const useGetTimeAdjustmentSummary = () => {
  return useSWR<TimeAdjustmentSummary>(
    `/api/v1/passport/me/toil-time-adjustment/summary`,
    getNestedDataFetcher,
  );
};
export const useChangePassport = (passportId: string) => {
  return fetchApi({
    method: 'PATCH',
    url: PATCH_PASSPORT_URL,
    data: { passportId: passportId },
    extraHeaders: {
      Authorization: `Bearer ${getCookie(COOKIE_KEY_ACCESS_TOKEN)}`,
    },
  });
};

export const useChangeLanguage = (language: string) => {
  // 비표준 언어값('kr', 'ko-KR' 등)이 계정에 저장되지 않도록 표준 코드로 정규화해서 전송
  return patchDataFetcher(CHANGE_LANGUAGE_URL, {
    lang: normalizeAppLanguage(language) ?? 'ko',
  });
};

export const useReviewTelecomSupportDocument = (
  fileUuid: string,
  mimeType: string,
  year: number,
  month: number,
  signal?: AbortSignal,
) => {
  return postDataFetcher<
    { fileUuid: string; mimeType: string; year: number; month: number },
    { data: PhoneBillResponse }
  >(
    TELECOM_SUPPORT_DOCUMENT_REVIEW_URL,
    {
      fileUuid,
      mimeType,
      year,
      month,
    },
    signal,
  );
};

// ── 업로드 진행률 / 스톨 감지 (PORTAL-12593) ────────────────────────
// 전송 중 이 시간 동안 보낸 바이트가 늘지 않으면 멈춘 것으로 보고 요청을 끊는다.
const UPLOAD_STALL_MS = 30000;
// 전송이 100% 끝나면 진행률 이벤트가 더 오지 않는다(서버가 처리 중). 그때부터는
// 스톨이 아니라 응답 대기이므로, 이 시간까지 기다렸다가 끊는다.
const UPLOAD_PROCESSING_TIMEOUT_MS = 120000;

export type UploadProgress = { percent: number; loaded: number; total: number };

/** 업로드가 멈춰서 중단된 경우 — 호출부가 네트워크 안내/재시도로 분기할 수 있게 구분한다. */
export class UploadStallError extends Error {
  constructor() {
    super('업로드가 멈춰 중단했습니다.');
    this.name = 'UploadStallError';
  }
}

export const useUploadFile = (
  obj?: File,
  privateMode?: boolean,
  signal?: AbortSignal,
  onProgress?: (progress: UploadProgress) => void,
) => {
  const controller = new AbortController();
  // 호출부가 넘긴 취소 신호도 함께 반영
  if (signal) {
    if (signal.aborted) controller.abort();
    else signal.addEventListener('abort', () => controller.abort());
  }

  let isStalled = false;
  let watchdogId: ReturnType<typeof setTimeout>;
  // 진척이 있을 때마다 다시 무장 — 정해진 시간 안에 다음 진척이 없으면 중단시킨다
  const armWatchdog = (ms: number) => {
    clearTimeout(watchdogId);
    watchdogId = setTimeout(() => {
      isStalled = true;
      controller.abort();
    }, ms);
  };
  armWatchdog(UPLOAD_STALL_MS);

  let lastLoaded = -1;
  return fetchApi<{ data: UploadResponse }>({
    extraHeaders: {
      'Content-Type': 'multipart/form-data',
    },
    method: 'POST',
    url: FILE_UPLOAD_URL,
    // 고정 타임아웃을 두면 느리지만 정상 진행 중인 대용량 업로드까지 끊긴다.
    // 상한은 위 watchdog 이 대신 책임진다.
    timeout: 0,
    data: {
      downloadType: privateMode ? 'private' : 'public',
      file: obj,
    },
    signal: controller.signal,
    onUploadProgress: (e) => {
      if (e.loaded <= lastLoaded) return; // 진척 없는 이벤트는 무시
      lastLoaded = e.loaded;
      const total = e.total ?? obj?.size ?? 0;
      const percent =
        total > 0 ? Math.min(100, Math.round((e.loaded / total) * 100)) : 0;
      onProgress?.({ percent, loaded: e.loaded, total });
      armWatchdog(
        percent >= 100 ? UPLOAD_PROCESSING_TIMEOUT_MS : UPLOAD_STALL_MS,
      );
    },
  })
    .then((res) => {
      clearTimeout(watchdogId);
      return res;
    })
    .catch((e) => {
      clearTimeout(watchdogId);
      // 우리가 끊은 것이면 axios 취소 에러 대신 스톨임을 알린다
      throw isStalled ? new UploadStallError() : e;
    });
};

export const useSubmitTelecomSupportClaim = (id: number) => {
  return postDataFetcher<{}, { data: any }>(TELECOM_SUPPORT_SUBMIT_URL(id), {});
};

export const useGetFileLink = (uuid: string) => {
  return fetchApi<{ data: DownLoadResponse }>({
    method: 'GET',
    url: `${FILE_DOWNLOAD_URL}?uuid=${uuid}`,
  });
};

export const useGetAudioLink = (uuid?: string) =>
  useSWR<DownLoadResponse>(
    uuid && uuid !== 'uploading' ? `${FILE_DOWNLOAD_URL}?uuid=${uuid}` : null,
    getNestedDataFetcher,
  );

export const useSetAudioFile = (
  talkFlowDocumentId: string,
  obj: Omit<Recording, 'state'>,
) =>
  putDataFetcher<Omit<Recording, 'state'>>(
    apiURL.TALK_FLOW_RECORDING_FILE(talkFlowDocumentId),
    obj,
  );

export const useDeleteAudioFile = (talkFlowDocumentId: string, uuid: string) =>
  deleteDataFetcher(apiURL.TALK_FLOW_RECORDING_FILE(talkFlowDocumentId), {
    uuid,
  });

export const useMyNotiList = () => {
  return useSWR<Notification[]>(
    MY_NOTIFICATION_OPTION_LIST_URL,
    getNestedNotificationDataFetcher<Notification[]>,
  );
};

export type PortalNoti = {
  templateKey: string;
  description: string;
  emailActivated: boolean;
  webActivated: boolean;
  appActivated: boolean;
};

export const useMyPortalNotiList = () => {
  return useSWR<{
    approval: PortalNoti[];
    jira: PortalNoti[];
  }>(MY_NOTIFICATION_PORTAL_OPTION_LIST_URL, getNestedNotificationDataFetcher);
};

export type NotificationType = 'email' | 'web' | 'app';

export const updateMyPortalOption = async (payload: {
  templateKey: string;
  notificationType?: NotificationType;
  activated: 0 | 1;
}) => {
  await putDataFetcher(
    `${process.env.NEXT_PUBLIC_NOTIFICATION_URL}/api/v1/notificationCenter/portal/option`,
    payload,
  );
};
export const updateMyPortalOptions = async (payload: {
  templateKeys: string[];
  activated: 0 | 1;
}) => {
  await putDataFetcher(
    `${process.env.NEXT_PUBLIC_NOTIFICATION_URL}/api/v1/notificationCenter/portal/option/options`,
    payload,
  );
};

export const useMyNotiOptionChange = ({
  templateKey,
  activated,
}: Pick<Notification, 'templateKey' | 'activated'>) => {
  return fetchApi({
    method: 'POST',
    url: MY_NOTIFICATION_OPTION_URL,
    baseURL: process.env.NEXT_PUBLIC_NOTIFICATION_URL,
    data: {
      templateKey,
      activated: activated ? 1 : 0,
    },
  });
};

export type Email = {
  id: string;
  sentDateTime: string;
  subject: string;
  isRead: boolean;
  sender: {
    emailAddress: {
      name: string;
      address: string;
    };
  };
  webLink: string;
};

export const useFetchEmailList = (
  readStatus: 'all' | 'unread',
  config: SWRConfiguration = {
    shouldRetryOnError: false, // 수동으로 재시도 로직이 있어서 기본 재시도는 막음
  },
) => {
  return useSWR(
    `${EMAIL_LIST_URL}?top=100${readStatus === 'all' ? '' : `&isRead=false`}`,
    (url: string) =>
      fetchApi<{ data: Email[] }>({
        method: 'GET',
        instance: msInstance,
        url,
        apiTokenType: ApiTokenType.MS,
      }),
    config,
  );
};

export const updateEmailIsRead = (payload: { id: string; isRead: boolean }) => {
  return fetchApi<{ data: PortalUserResponse }>({
    method: 'PATCH',
    url: `${EMAIL_LIST_URL}/${payload.id}`,
    instance: msInstance,
    apiTokenType: ApiTokenType.MS,
    data: {
      isRead: payload.isRead,
    },
  });
};

export type FetchCalendarListResponse = {
  data: {
    displayRange: {
      start: string;
      end: string;
      formatted: string;
    };
    events: CalendarEvent[];
  };
};

export const useFetchThisWeekCalendarList = (
  offset: number,
  timeZone: string,
  config: SWRConfiguration = {
    shouldRetryOnError: false, //수동으로 재시도 로직이 있어서 기본 재시도는 막음
  },
) => {
  return useSWR(
    // offset: 현재 주를 기준으로 조회할 주차(예: 0은 이번 주, -1은 지난 주, 1은 다음 주)
    `${CALENDAR_LIST_URL}?weekOffset=${offset}&timezone=${timeZone}`,
    (url: string) =>
      fetchApi<FetchCalendarListResponse>({
        method: 'GET',
        instance: msInstance,
        url,
        apiTokenType: ApiTokenType.MS,
      }),
    config,
  );
};

export const usePassportInfo = (jwtAccessToken: string) => {
  return fetchApi<{ data: PortalUserResponse }>({
    method: 'GET',
    url: PORTAL_PASSPORT_URL,
    extraHeaders: {
      Authorization: `Bearer ${jwtAccessToken}`,
    },
  });
};

export const useGetMyInfo = () =>
  useSWR<PortalUserResponse>(PORTAL_PASSPORT_URL, getNestedDataFetcher);

export const useSendMessage = (id: string, obj: { message: string }) =>
  postDataFetcher(`${PASSPORT_BASE_URL}/${id}/happy-birthday/email`, obj);

export const fetchLeaveHistory = ({
  passportId,
  year,
}: {
  passportId?: string | null;
  year: number;
}) =>
  useSWR<{
    leaves: {
      documentId: string;
      startDate: string;
      endDate: string;
      days: number;
      duration: LeaveDuration;
      cancelType: LeaveCancelType;
    }[];
    overages: number;
    monthlyLeaveGranted: number;
    annualLeaveGranted: number;
  }>(
    `${PASSPORT_BASE_URL}/${passportId}/leave/history?year=${year}`,
    getNestedDataFetcher,
  );

export const useGetDday = () =>
  useSWR<Dday[]>(
    `${BASE_CALENDAR_URL}/event/d-day?sortType=end.datetime&orderType=asc`,
    getNestedDataFetcher,
  );

/* Social API */
export const useSocialCategories = (
  existData: boolean,
  isDisplay: boolean | undefined,
  config = swrConfig,
) =>
  useSWR<CategoryType[]>(
    existData
      ? null
      : apiURL.BOARD_CATEGORY_LIST_FILTER(
          makeQueryString({ listSize: 20000, isDisplay }, true, true),
        ),
    getNestedDataFetcher,
    config,
  );
// 소셜 목록과 자동완성이 같은 카테고리 범위로 검색하도록 공용으로 쓴다
const getSocialCategoryParams = (categoryId = '', groupId = '') => ({
  categoryId: categoryId === 'all' ? '' : categoryId,
  categoryGroupId: groupId,
  isCategoryDisplay: !EventCategoryIds.includes(categoryId),
});

export const useSocialSearch = (
  searchText = '',
  currentDate = '',
  isHome = false,
  categoryId = '',
  groupId = '',
) => {
  const params: any = {
    keyword: searchText,
    isDelete: false,
  };
  const shouldFetch = Boolean(currentDate && searchText);
  if (isHome) {
    params.homeDisplayEndedAt = currentDate;
    params.homeDisplayStartedAt = currentDate;
    params.displaySections = 'rightSection,rightFixSection';
  } else {
    params.displayEndedAt = currentDate;
    params.displayStartedAt = currentDate;
    Object.assign(params, getSocialCategoryParams(categoryId, groupId));
  }
  return useSWR<BoardListItem[]>(
    shouldFetch
      ? `/api/v1/board/search${makeQueryString(params, true, true)}`
      : null,
    getNestedDataFetcher,
  );
};

export const useReservedBoardList = (passportId = '', currentDate = '') => {
  const { data, size, setSize, isValidating, mutate, isLoading } =
    useSWRInfinite<any>(
      (index, previousPageData) => {
        const params = {
          createdBy: passportId,
          reservedDisplayStartedAt: currentDate,
          isDelete: false,
        };
        const shouldFetch = Boolean(currentDate);
        return shouldFetch
          ? `${apiURL.BOARD_SEARCH}/${makeQueryString(params, true, true)}`
          : null;
      },
      getSocialDataNestedDataFetcherWithMeta,
      { revalidateFirstPage: true, revalidateOnFocus: false }, // 즐겨찾기 반영 가져오려면 revalidateFirstPage true여야 함
    );

  const { content, totalPage } = useMemo(() => {
    if (data) {
      const flatData = [...data.flatMap((page) => page)];
      return {
        content: [...flatData.map((page) => page.content)],
        totalPage: flatData[0].meta.endPage,
      };
    }
    return { content: [], totalPage: null };
  }, [data]);

  const loadNext = () => setSize((prev) => prev + 1);
  const hasNext = useMemo(() => {
    if (!totalPage) return false;
    return size < totalPage;
  }, [size, totalPage]);
  const isRefreshing = isValidating && data && data.length < size;

  return {
    data: data ? content : [],
    realData: data,
    mutate,
    loadNext,
    hasNext,
    isValidating,
    isLoading,
    isRefreshing,
    size,
  };
};

export const useMainBoardWithFilter = (
  displaySection = '',
  currentDate = '',
  listSize?: number,
  searchText?: string,
  categoryIds?: string[],
  sortType?: string,
  orderType?: 'desc' | 'asc',
) => {
  const shouldFetch = Boolean(currentDate);
  const params: any = {
    displaySections: displaySection,
    homeDisplayEndedAt: currentDate,
    homeDisplayStartedAt: currentDate,
    isDelete: '0',
    categoryId: categoryIds ? categoryIds.join('') : '',
    sortType: sortType ?? '',
    orderType: orderType ?? '',
    displayStartedAt: currentDate,
    displayEndedAt: currentDate,
  };
  if (listSize) {
    params.listSize = listSize;
  }
  if (searchText) {
    params.subject = searchText;
  }

  return useSWR<BoardContentData[]>(
    shouldFetch
      ? `${apiURL.BOARD_SEARCH}${makeQueryString(params, true)}`
      : null,
    getNestedDataFetcher,
  );
};

export const useSocialBoardCountWithFilter = (
  isBookmark = false,
  currentDate = '',
  passportId = '',
) => {
  const { data, isLoading } = useSWRInfinite<any>(
    () => {
      const params: any = {
        listSize: 1000,
        isDelete: false,
      };

      const shouldFetch = Boolean(currentDate);

      //[PORTAL-3705 이슈 참고] off시 isBookmark 호출x, on시 isBookmark 1으로 호출
      if (isBookmark) {
        params.isBookmark = true;
      }

      if (passportId) {
        params.createdBy = passportId;
        params.reservedDisplayStartedAt = currentDate;
      }

      return shouldFetch
        ? `/api/v1/board/filter/count${makeQueryString(params, true, true)}`
        : null;
    },
    getSocialDataNestedDataFetcherWithMeta,
    {
      revalidateFirstPage: true,
      revalidateOnFocus: false,
    }, // 즐겨찾기 반영 가져오려면 revalidateFirstPage true여야 함
  );

  const content = useMemo(() => {
    const firstItem = data?.[0]?.[0]?.content;
    return typeof firstItem === 'object' && firstItem !== null
      ? firstItem
      : { totalCount: 0 };
  }, [data]);

  return {
    data: content,
    isLoading,
  };
};

export const useSearchSocialBoardWithFilter = (
  searchText = '',
  categoryId = '',
  groupId = '',
  isBookmark = false,
  isUnRead = false,
  displaySections = '',
  currentDate = '',
) => {
  const { data, size, setSize, isValidating, mutate, isLoading } =
    useSWRInfinite<any>(
      (index) => {
        const params: any = {
          keyword: searchText,
          ...getSocialCategoryParams(categoryId, groupId),
          listSize: 48,
          displayEndedAt: currentDate,
          displayStartedAt: currentDate,
          isDelete: false,
          currentPage: index + 1,
          // sortType: 'displayStartedAt', [portal-3701 이슈 참고]
          // orderType: 'desc',
          // displaySections: 'bannerSection', //todo 테스트용
        };

        const shouldFetch = Boolean(currentDate);

        if (displaySections) {
          params.displaySections = displaySections;
        }

        //[PORTAL-3705 이슈 참고] off시 isBookmark 호출x, on시 isBookmark 1으로 호출
        if (isBookmark) {
          params.isBookmark = true;
        }

        //[PORTAL-3704 이슈 참고] off시 isRead 호출x, on시 isRead 0으로 호출
        if (isUnRead) {
          params.isRead = false;
        }

        // PORTAL-8155 OpenSearch 운영까지 적용.
        return shouldFetch
          ? `/api/v1/board/search${makeQueryString(params, true, true)}`
          : null;
      },
      getSocialDataNestedDataFetcherWithMeta,
      { revalidateFirstPage: true, revalidateOnFocus: false }, // 즐겨찾기 반영 가져오려면 revalidateFirstPage true여야 함
    );

  const { content, totalPage } = useMemo(() => {
    if (data) {
      const flatData = [...data.flatMap((page) => page)];
      return {
        content: [...flatData.map((page) => page.content)],
        totalPage: flatData[0].meta.endPage,
      };
    }
    return { content: [], totalPage: null };
  }, [data]);

  const loadNext = () => setSize((prev) => prev + 1);
  const hasNext = useMemo(() => {
    if (!totalPage) return false;
    return size < totalPage;
  }, [size, totalPage]);
  const isRefreshing = isValidating && data && data.length < size;

  return {
    data: data ? content : [],
    realData: data,
    mutate,
    loadNext,
    hasNext,
    isValidating,
    isLoading,
    isRefreshing,
    size,
  };
};

type BoardPostFile = {
  name: string;
  link: string;
};

export type BoardPost = {
  subject: string;
  content: string;
  files: {
    attachments: BoardPostFile[];
    thumbnails: BoardPostFile[];
    slideImages: BoardPostFile[];
  };
  categories: string[];
  config: {
    isTemporary: boolean;
    viewType: 'normal' | 'slide';
    displaySections: BoardFormData['displaySections'][];
    displayStartedAt?: string;
    displayEndedAt?: string;
    commentSection: BoardFormData['commentPosition'];
    isImportant: boolean;
    editorType: 'Froala' | 'LexicalEditor';
    homeDisplayStartedAt?: string;
    homeDisplayEndedAt?: string;
    isListSubjectVisible: boolean;
  };
};

const getBoardPostPayloadWidthDefaultValues = ({
  config,
  ...payload
}: BoardPost) => {
  return {
    ...payload,
    config: {
      ...config,
      isCommentEnable: true,
      feedbackSettings: {
        like: true,
        recommend: true,
      },
    },
    commentGroupConfig: {
      type: 'normal',
      reply: 0,
      anonymous: 0,
      feedback: 1,
      attachment: 0,
      delete: 1,
    },
  };
};

/** 게시글 작성 */
//TODO: 기존 useCreateBoard랑 비교
export const useCreateBoardPost = async (
  payload: BoardPost,
): Promise<BoardDetailData> => {
  const {
    data: { documentId },
  } = await postDataFetcher<BoardPost, { data: { documentId: string } }>(
    apiURL.BOARD_CREATE,
    getBoardPostPayloadWidthDefaultValues(payload),
  );

  return await getNestedDataFetcher(apiURL.BOARD_DETAIL(documentId));
};
/** 게시글 수정 */
export const useUpdateBoardPost = async (
  payload: BoardPost & { documentId: string },
) => {
  await putDataFetcher(apiURL.BOARD_UPDATE, {
    ...getBoardPostPayloadWidthDefaultValues(payload),
    documentId: payload.documentId,
  });

  return true;
};

/** 게시글 배포 */
export const useBoardDeploy = async (documentId: string): Promise<void> => {
  await postDataFetcher(apiURL.BOARD_DEPLOY(documentId), {});
};

/** 게시글 배포 상태 조회 */
export const useGetBoardDeployStatus = async (
  documentId: string,
): Promise<BoardDeployStatusResponse> => {
  return await getNestedDataFetcher(apiURL.BOARD_DEPLOY_STATUS(documentId));
};

/* 게시글 읽음 처리 */
export const readBoard = (documentId: string, mutate?: () => void) => {
  putDataFetcher(apiURL.BOARD_READ(documentId), {}).then(() => mutate?.());
};
/* 게시글 조회 */
export const useGetBoardDetail = (
  documentId?: string,
  config?: SWRConfiguration,
) => {
  return useSWR<BoardDetailData>(
    documentId ? apiURL.BOARD_DETAIL(documentId) : null,
    getNestedDataFetcher,
    config,
  );
};

/** 게시글 수정용 데이터 조회 */
export const useGetEditDetailBoard = (
  isTemporary: boolean,
  documentId?: string,
) => {
  const {
    data: boardDetailData,
    error: boardDetailError,
    isLoading: boardDetailIsLoading,
    isValidating,
    mutate,
  } = useGetBoardDetail(documentId, {
    revalidateOnMount: true,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  const {
    data: fullCategoryList,
    error: categoryError,
    isLoading: categoryIsLoading,
  } = useSWR<CategoryType[]>(
    boardDetailData
      ? apiURL.BOARD_CATEGORY_LIST_FILTER(
          makeQueryString({ listSize: 20000 }, true),
        )
      : null,
    getNestedDataFetcher,
    { revalidateOnFocus: false },
  );

  const [formData, setFormData] = useState<BoardFormData>();
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    const processData = async () => {
      if (!boardDetailData || !fullCategoryList) {
        setFormData(undefined);
        return;
      }

      setIsProcessing(true);
      const data = await boardDetailDataToBoardFormData(
        isTemporary,
        boardDetailData,
        fullCategoryList,
      );
      setFormData(data);
      setIsProcessing(false);
    };

    processData();
  }, [isTemporary, boardDetailData, fullCategoryList]);

  const error = boardDetailError || categoryError;
  const isLoading =
    boardDetailIsLoading || categoryIsLoading || isValidating || isProcessing;

  return {
    data: formData,
    error,
    isLoading,
    mutate,
  };
};
/** 임시글 조회 */
export const useGetTempBoard = () => {
  return useSWR<BoardDetailData[]>(
    `${apiURL.BOARD_SEARCH}?isTemporary=1&isDelete=0`,
    getNestedDataFetcher,
    { revalidateOnFocus: false },
  );
};

/* 게시글 삭제 */
export const useDeleteBoard = async (
  documentId: string,
): Promise<boolean | string> => {
  if (!documentId) return '잘못된 요청입니다. 새로고침 후 다시 시도해 주세요.';
  try {
    await deleteDataFetcher(apiURL.BOARD_DELETE(documentId));
    return true;
  } catch (error: any) {
    console.error(error);
    return error.response?.data?.message || false;
  }
};

/* 임시글 전체 삭제 */
export const useDeleteTempBoard = async (
  tempBoardList: string[],
): Promise<boolean> => {
  if (tempBoardList.length === 0) {
    return true;
  }

  await Promise.all(
    tempBoardList.map((id) => deleteDataFetcher(apiURL.BOARD_DELETE(id))),
  );

  return true;
};

/* 게시글 즐겨찾기 변경 */
export const changeBoardBookmark = async (
  documentId: string,
  isBookmark: boolean,
) => {
  try {
    if (isBookmark) {
      await putDataFetcher(apiURL.BOARD_FEEDBACK(documentId), {
        type: 'bookmarks',
      });
      return true;
    } else {
      await deleteDataFetcher(apiURL.BOARD_FEEDBACK(documentId), {
        type: 'bookmarks',
      });
      return true;
    }
  } catch (error) {
    console.error(error);
    return false;
  }
};

/* 게시글 피드백 유저 조회 */
export const getFeedbackUser = (documentId: string, type = 'likes') => {
  const swrKey = documentId
    ? `${apiURL.BOARD_FEEDBACK(documentId)}?type=${type}&listSize=9999`
    : null;
  return useSWR<User[]>(swrKey, getNestedDataFetcher);
};
/* 게시글 좋아요 변경 */
export const changeLikeBoard = async (documentId: string, isLike: boolean) => {
  try {
    if (isLike) {
      await putDataFetcher(apiURL.BOARD_FEEDBACK(documentId), {
        type: 'likes',
      });
      return true;
    } else {
      await deleteDataFetcher(apiURL.BOARD_FEEDBACK(documentId), {
        type: 'likes',
      });
      return true;
    }
  } catch (error: any) {
    console.error(error);
    return false;
  }
};
export type Comment = {
  id: string;
  commentGroupId: string;
  content: string;
  deletedBy: null | string;
  deletedAt: null | string;

  createdBy: User;
  createdAt: string;

  status: {
    isAnonymous: number;
    isTopHold: number;
  };
  feedback: {
    agree: any[];
    agreeCount: number;
    disagree: any[];
    disagreeCount: number;
    recommend: any[];
    recommendCount: number;
    isAgree: boolean;
    isDisagree: boolean;
    isRecommend: boolean;
  };
  customData: any[];
  isDeleteEnable: boolean;

  //새로운 스펙
  attachments?: RemoteFile[];
  updatedAt: string;
  isUpdated: boolean;
  isDeleted: boolean;
};

/* 댓글 조회 */
export const getCommentListKey = (
  commentGroupId: string,
  paramsObj: ListParams,
) =>
  commentGroupId
    ? `${
        apiURL.COMMENT_LIST
      }?commentGroupId=${commentGroupId}&${makeQueryString(
        paramsObj,
        false,
        false,
      )}`
    : null;

export const useCommentList = (
  commentGroupId: string,
  paramsObj: ListParams,
) => {
  const swrKey = getCommentListKey(commentGroupId, paramsObj);
  return useSWR<Comment[]>(swrKey, getNestedDataFetcher);
};
/* 댓글 삭제 */
export const useDeleteComment = async (commentId: string) => {
  await deleteDataFetcher(apiURL.COMMENT_DETAIL(commentId));
};
/* 댓글 반응 업데이트 */
export const useLikeComment = async (
  commentId: string,
  isLike: boolean,
  service: BoardDetailCommentProps['service'],
) => {
  if (!commentId) throw '잘못된 요청입니다. 새로고침 후 다시 시도해 주세요.';
  return await postDataFetcher(apiURL.COMMENT_FEEDBACK, {
    commentId,
    feedback: { recommend: isLike ? 1 : 2 },
    service,
  });
};
/* 댓글 추가 */
type CommentPayload = {
  commentGroupId: string;
  content: string;
  service: string;
  customData?: unknown;
  mentions?: string[];
};
export const useCreateComment = async (payload: CommentPayload) =>
  await postDataFetcher(apiURL.COMMENT_CREATE, payload);

/* 댓글 수정 */
export const useUpdateComment = async (
  payload: {
    commentId?: string;
  } & CommentPayload,
) => {
  if (!payload.commentId) return;

  return await postDataFetcher(apiURL.COMMENT_UPDATE, payload);
};
/* 댓글 번역 */
type TranslateCommentPayload = {
  commentId: string;
  // @ref: 언어 자동번역이라 보내지 않음
  // sourceLanguage?: ApiLanguageCode;
  targetLanguage: ApiLanguageCode;
};
export const translateComment = async (payload: TranslateCommentPayload) =>
  await postDataFetcher<
    Omit<TranslateCommentPayload, 'commentId'>,
    {
      data: {
        commentId: string;
        targetLanguage: string;
        translatedContent: string;
      };
    }
  >(apiURL.COMMENT_TRANSLATE(payload.commentId), {
    targetLanguage: payload.targetLanguage,
  });

export const useGetBirthdays = () =>
  useSWR<IBirthdayObj>(BIRTHDAY_API_URL, getNestedDataFetcher<IBirthdayObj>);

export const useGetNewBook = () =>
  useSWR<NewBookData>(NEW_BOOK_URL, getNestedDataFetcher);

export const useChangedJob = (arg: MyJob) =>
  putDataFetcher(CHANGE_JOB_DESCRIPTION_URL, arg);

export const useGetJobList = (search?: string) =>
  useSWR<SearchJobList>(
    search
      ? `${JOB_LIST_URL}?listSize=500&currentPage=1&keyword=${search}`
      : `${JOB_LIST_URL}?listSize=500&currentPage=1`,
    getNestedMetaDataFetcher,
  );

export const useGetOrganizationChart = (config?: SWRConfiguration) =>
  useSWR<Organizations>(
    `${ORGANIZATION_URL}?visibilityType=orgChart`,
    getNestedMetaDataFetcher,
    config,
  );

export const useGetOrganizationPassports = (
  orgCode: string,
  config?: SWRConfiguration,
) =>
  useSWR<Passport[]>(
    `${ORGANIZATION_PASSPORT_URL}?orgCode=${orgCode}&orgChartVisibility=true&sort=${DefaultOrganization}`,
    getNestedDataFetcher,
    config,
  );

// 전자결재 API 훅 — hooks/apiHooks/approval.ts 에서 관리
export {
  useGetApprovalType,
  useGetApprovalAllType,
} from '@/hooks/apiHooks/approval';

export {
  useGetMyApprovalData,
  useRecentReadApproval,
  useSearchApproval,
  useGetFilterRecommend,
  useGetCombinedDepartment,
} from '@/hooks/apiHooks/approval';

export const useGetPassportSearchHistory = () =>
  useSWR<string[]>(PASSPORT_SEARCH_URL, getNestedDataFetcher);

export const useDeletePassportSearchHistory = (keyword: string) => {
  return deleteDataFetcher(`${PASSPORT_SEARCH_URL}/${keyword}`);
};

export const useGetLeader = (orgCode: string) =>
  useSWR<Passport[]>(
    orgCode ? `${ORGANIZATION_BASE_URL}/${orgCode}` : null,
    getNestedDataFetcher,
  );

/**
 * date: 조회 기준 날짜(YYYY-MM-DD). 미지정 시 백엔드가 오늘 날짜로 조회 (PORTAL-13855)
 * null 이면 호출하지 않는다 — 기준별 목록(v2)을 쓰는 화면에서 v1 중복 호출을 막기 위함
 */
export const useGetSeasons = (date?: string | null) =>
  useSWR<Season[]>(
    date === null
      ? null
      : date
      ? `${SEASONS_URL}?startDate=${date}&endDate=${date}`
      : SEASONS_URL,
    getNestedDataFetcher,
  );

/**
 * 기준별 시즌 목록 — 항목의 sesnType 으로 상품/운영을 가른다 (PORTAL-14097)
 * null 이면 호출하지 않는다 — 기준 선택이 꺼진 환경에서 v1 목록만 쓰는 화면용
 */
export const useGetSeasonsV2 = (date: string | null) =>
  useSWR<SeasonV2[]>(
    date === null ? null : `${SEASONS_V2_URL}?date=${date}`,
    getNestedDataFetcher,
  );

/**
 * 카테고리별 시즌 구성 (PORTAL-14418). 시트를 열 때와 시트 안에서 카테고리를 바꿀 때만 호출한다.
 * enabled 가 false 면 호출하지 않는다 — 목록 진입·카드 펼침에서는 나가지 않아야 한다.
 *
 * 캐시는 시트를 한 번 여는 동안만 유지한다 (PORTAL-14583).
 *  - 이미 본 카테고리로 돌아오면 캐시만 쓰고 다시 부르지 않는다(revalidateIfStale: false)
 *  - 시트를 닫고 다시 열면 `session` 이 바뀌어 키가 달라지고, 그때 한 번 새로 부른다
 * session 은 키에만 들어가고 요청 URL 에는 붙지 않는다.
 */
export const useGetCategorySeason = (
  {
    brand,
    date,
    period,
    categorySubGroupCode,
    categoryItemCode,
  }: CategorySeasonParams,
  enabled = true,
  session = 0,
) =>
  useSWR<CategorySeasonBreakdown>(
    enabled && brand && categorySubGroupCode
      ? [
          `${CATEGORY_SEASON_URL(brand)}?${buildQueryParams({
            date,
            period,
            categorySubGroupCode,
            categoryItemCode,
          })}`,
          session,
        ]
      : null,
    ([url]: [string, number]) =>
      getNestedDataFetcher<CategorySeasonBreakdown>(url),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false,
      shouldRetryOnError: false,
    },
  );

/** 시즌 기준이 운영(OPER)일 때만 파라미터를 붙인다 — 상품(PRDT)은 BE 기본값이라 생략 (PORTAL-13975) */
export const seasonBasisQuery = (seasonBasis?: SeasonBasis) =>
  seasonBasis === 'OPER' ? `&${SEASON_BASIS_PARAM}=OPER` : '';

export const useGetSaleMainData = ({ season, date }: SalesMainParams) =>
  useSWR<SalesMain>(
    `${SALES_MAIN_URL(season)}?date=${date}`,
    getNestedDataFetcher,
    {
      shouldRetryOnError: false, // 에러 발생 시 재시도를 하지 않도록 설정
      revalidateOnFocus: false,
    },
  );

export const useGetSaleMainDataV2 = ({
  season,
  date,
  seasonBasis,
}: SalesMainParams) =>
  useSWR<BrandSales[]>(
    `${SALES_MAIN_URL_V2(season)}?date=${date}${seasonBasisQuery(seasonBasis)}`,
    getNestedDataFetcher,
    {
      shouldRetryOnError: false, // 에러 발생 시 재시도를 하지 않도록 설정
      revalidateOnFocus: false,
    },
  );

export const useGetSalesCompareDate = (date: string) =>
  useSWR<SalesCompareDate[]>(
    date ? `${SALES_COMPARE_DATE_URL}?date=${date}` : null,
    getNestedDataFetcher,
    {
      shouldRetryOnError: false,
      revalidateOnFocus: false,
    },
  );

export const usePing = () =>
  useSWR(PING_URL, getNestedDataFetcher, appFetchConfig);

export const useGetStoreFilter = (brand: string) =>
  useSWR<StoreFilter>(
    `${`api/v1/sales/brand/${brand}/shop/filters`}`,
    getNestedDataFetcher,
  );

export const useGetBrandStoreData = ({
  season,
  date,
  brand,
  period,
  channelName,
  regionName,
  gradeName,
  shopStatus,
  seasonBasis,
}: StoreListParams) =>
  useSWR<NewShopDetailData[]>(
    `${ALL_STORE_SALES(
      season,
      brand,
    )}?date=${date}&period=${period}&${buildQueryParams({
      channelName,
      regionName,
      gradeName,
      shopStatus,
    })}${seasonBasisQuery(seasonBasis)}`,
    getNestedDataFetcher,
  );

export const useGetTypeMode = ({
  season,
  date,
  brand,
  period,
  shopCode = 'ALL',
  seasonBasis,
}: SalesBrandStoresParams & { shopCode?: string }) =>
  useSWR<SalesTypeResponse[]>(
    `${SALES_BY_TYPE_URL(
      season,
      brand,
      shopCode,
    )}?date=${date}&period=${period}${seasonBasisQuery(seasonBasis)}`,
    getNestedDataFetcher,
  );

export const useGetBestItemsV2 = ({
  season,
  date,
  brand,
  period,
  shopCode = 'ALL',
  productKindCode,
}: SalesParams & {
  productKindCode?: string[];
}) => {
  const query = buildQueryParams({
    date,
    period,
    productKindCode,
  });

  return useSWR<{ pagination: Pagination; response: BestItemTypeV2[] }>(
    `${SALES_BY_BEST_V2_URL(season, brand, shopCode)}?${query}`,
    getNestedDataFetcher,
  );
};

export const useGetItemSaleDetail = ({
  season,
  brand,
  productCode,
  shopCode,
  date,
  period,
}: ItemDetailParams & { date: string; period: Period }) =>
  useSWR<SalesDetail[]>(
    productCode
      ? `${ITEM_SALES_DETAIL_URL({
          season,
          brand,
          productCode,
          shopCode,
        })}?date=${date}&period=${period}`
      : null,
    getNestedDataFetcher,
  );

export const useGetItemByStoreRank = ({
  season,
  brand,
  productCode,
  colorCode,
  date,
  period,
}: SalesByStoreRanking & { date: string; period: Period }) =>
  useSWR<ItemSalesByStoreRanking[]>(
    productCode && colorCode
      ? `${BEST_SHOP_URL({
          season,
          brand,
          productCode,
          colorCode,
        })}?date=${date}&period=${period}`
      : null,
    getNestedDataFetcher,
  );

export const useGetRivalRank = (date: string) =>
  useSWR<RivalRankResponse[]>(
    `${RIVAL_RANK_URL}?date=${date}`,
    getNestedDataFetcher,
  );

export const useGetRivalRankStandardCompany = ({
  date,
  brand,
  shopCode,
}: {
  date: string;
  brand: string;
  shopCode?: string;
}) =>
  useSWR<RivalCompanyStandardResponse[]>(
    `${RIVAL_RANK_STANDARD_COMPANY_URL(brand, shopCode)}?date=${date}`,
    getNestedDataFetcher,
  );

export const useGetRivalRankStore = ({
  date,
  brand,
}: {
  date: string;
  brand: string;
}) =>
  useSWR<RivalStoreResponse[]>(
    `${RIVAL_RANK_STORE_URL(brand)}?date=${date}&brand=${brand}`,
    getNestedDataFetcher,
  );

export const useGetCalendarId = () =>
  useSWR<CalendarId[]>(
    `${BASE_CALENDAR_URL}?keyword=대한민국 날씨`,
    getNestedDataFetcher,
  );

export const useGetWeather = ({
  calendarId,
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
  calendarId?: string;
}) =>
  useSWR<Weather[]>(
    calendarId
      ? `${BASE_CALENDAR_URL}/${calendarId}/event?startDatetime=${startDate}&endDatetime=${endDate}&timezone=Asia/Seoul`
      : null,
    getNestedDataFetcher,
  );

export const useGetAnalysis = ({ season, date }: SalesMainParams) =>
  useSWR<BrandSaleBase[]>(
    `${SALES_ANALYSIS_URL}?date=${date}&season=${season}`,
    getNestedDataFetcher,
  );

export const useGetDetailByChannel = ({
  brand,
  date,
  total,
}: {
  brand: string;
  date: string;
  total: boolean;
}) =>
  useSWR<ChannelInfo[]>(
    `${SALES_BY_CHANNEL_URL(brand)}?date=${date}&total=${total}`,
    getNestedDataFetcher,
  );

export const useGetDetailBySeason = ({
  brand,
  date,
}: {
  brand: string;
  date: string;
}) =>
  useSWR<SeasonInfo[]>(
    `${SALES_BY_SEASON_URL(brand)}?date=${date}`,
    getNestedDataFetcher,
  );

export const useGetDetailByItem = ({
  brand,
  date,
}: {
  brand: string;
  date: string;
}) =>
  useSWR<ItemInfo[]>(
    `${SALES_BY_Item_URL(brand)}?date=${date}`,
    getNestedDataFetcher,
  );

export const useGetItemDetail = ({
  season,
  brand,
  productCode,
  date,
}: ItemParams) =>
  useSWR<{
    itemImageList: ItemImageList[];
    itemDetail: ItemDetail;
    display_rows: ItemDetailRow[];
  }>(
    `${PRODUCT_DETAIL_URL({ season, brand, productCode, date })}`,
    getNestedDataFetcher,
  );

export const useGetItemSalesByColor = ({
  season,
  brand,
  productCode,
  date,
}: ItemParams) =>
  useSWR<SaleByColorData[]>(
    `${PRODUCT_SALES_BY_COLORS_URL({ season, brand, productCode, date })}`,
    getNestedDataFetcher,
  );

export const useGetShopInfo = ({
  season,
  date,
  brand,
  period,
  shopCode,
}: ShopInfoParams) =>
  useSWR<ShopInfo>(
    `${SHOP_INFO_URL(season, brand, shopCode)}?date=${date}&period=${period}`,
    getNestedDataFetcher,
  );

export {
  deleteApprovalKeywordUsingBody,
  useSaveApprovalSearch,
} from '@/hooks/apiHooks/approval';

/** year 생략 시 올해 */
export const useGetVacationStatus = (
  passportId: string,
  year?: number,
  config?: SWRConfiguration<VacationStatus>,
) =>
  useSWR<VacationStatus>(
    passportId
      ? `${PASSPORT_BASE_URL}/${passportId}/leave/status${
          year ? `?year=${year}` : ''
        }`
      : null,
    getNestedDataFetcher,
    config,
  );

export const useGetBrandPermissionMissing = () =>
  useSWR<string[]>(BRAND_PERMISSION_MISSING_URL, getNestedDataFetcher);

export const useSearchGpt = async (keyword?: string) => {
  const { data } = await fetchApi<{ data: NlResponse }>({
    method: 'GET',
    url: `${SEARCH_GPT_EMPLOYEE_URL}?answer=${keyword}`,
  });

  const completedData = await getComplete({
    threadId: data.threadId,
    id: data.id,
  });

  if (!completedData) {
    throw new Error('getComplete failed');
  }

  return getMessage({ threadId: data.threadId });
};

const getComplete = async ({
  threadId,
  id,
  maxRetries = 100, // 재시도 제한
  interval = 300, // 요청 간격
}: {
  threadId: string;
  id: string;
  maxRetries?: number;
  interval?: number;
}): Promise<NlResponse | null> => {
  let retries = 0;

  while (retries < maxRetries) {
    try {
      const res = await fetchApi<{ data: NlResponse }>({
        method: 'GET',
        url: `/api/v1/labs/assistant/threads/${threadId}/runs/${id}`,
      });

      if (res.data.status === 'completed') {
        return res.data;
      }
    } catch (error: unknown) {
      if (isAxiosError(error)) {
        const status = error.response?.status;
        const message = error.response?.data?.message || 'Unknown error';
        throw new Error(`getComplete failed with status ${status}: ${message}`);
      } else {
        throw new Error(`Unexpected error in getComplete: ${String(error)}`);
      }
    }
    retries++;
    await new Promise((resolve) => setTimeout(resolve, interval));
  }

  throw new Error(`getComplete over try count: ${maxRetries}`);
};

const getMessage = async ({ threadId }: { threadId: string }) => {
  try {
    const { data } = await fetchApi<{ data: GptResponse }>({
      method: 'GET',
      url: `/api/v1/labs/assistant/threads/${threadId}/messages/latest`,
    });

    return data;
  } catch (error) {
    throw new Error(`getMessage failed for threadId: ${threadId}`);
  }
};

export {
  useBookMark,
  useSetApprovalFavoriteFilter,
  useGetApprovalFavoriteFilter,
  useDeleteApprovalFavoriteFilter,
  useGetFavoriteFilter,
  useModifyFavoriteFilter,
} from '@/hooks/apiHooks/approval';

export const useResetPasswordFreshFarm = (
  passportId: string,
  smsVerification: SmsVerification,
  passwordForm: PasswordForm,
) => {
  return postDataFetcher(
    `/api/v1/passport/${passportId}/fresh-farm/user/password/reset`,
    {
      smsVerificationId: smsVerification.verificationId,
      smsVerificationCode: smsVerification.verificationCode,
      newPassword: passwordForm.updatePassword,
      confirmPassword: passwordForm.updateConfirmPassword,
    },
  );
};

export const useUpdatePasswordFreshFarm = (
  passwordId: string,
  { currentPassword, updatePassword, updateConfirmPassword }: PasswordForm,
) => {
  return patchDataFetcher(
    `/api/v1/passport/${passwordId}/fresh-farm/user/password`,
    {
      currentPassword,
      newPassword: updatePassword,
      confirmPassword: updateConfirmPassword,
    },
  );
};

export const useGetSessionId = () =>
  postDataFetcher<{}, { session_id: string }>(FAQ_SESSION_URL, {});

export const useGetFaqMessage = ({
  session_id,
  message,
  signal,
}: {
  session_id: string;
  message: string;
  signal?: AbortSignal;
}) =>
  postDataFetcher<{ message: string }, { answer: string }>(
    FAQ_MESSAGE_URL(session_id),
    { message },
    signal,
  );

export const useGetCongestion = (fetch?: boolean) =>
  useSWR<Congestion>(fetch ? CONGESTION_URL : null, getNestedDataFetcher);

export const useGetQrCode = () =>
  useSWR<{ cardNumber: string }>(QR_NUM_URL, getNestedDataFetcher);

export const requestSummarize = (docId: string, params: SummarizeParams) =>
  postDataFetcher<SummarizeParams, { data: string }>(
    `${BASE_TALK_FLOW_URL}/document/${docId}/summarize`,
    params,
  );

// ── AI 채팅 (PORTAL-11968) ──────────────────────────────
// 질문 송신 — 비동기(202), sessionId/aiPipelineId 반환. 답변은 SSE로 수신.
export const postTalkFlowChat = (
  docId: string,
  body: TalkFlowChatSendRequest,
) =>
  postDataFetcher<TalkFlowChatSendRequest, { data: TalkFlowChatSendResponse }>(
    apiURL.TALK_FLOW_CHAT(docId),
    body,
  );

// 본인 세션 목록 (최신순)
export const useTalkFlowChatSessions = (
  docId?: string,
  config?: SWRConfiguration,
) =>
  useSWR<TalkFlowChatSession[]>(
    docId ? apiURL.TALK_FLOW_CHAT_SESSIONS(docId) : null,
    getNestedDataFetcher,
    config,
  );

// 세션 메시지 이력 (최신순). beforeId 로 무한스크롤 페이지네이션.
export const getTalkFlowChatMessages = (
  docId: string,
  sessionId: string,
  params?: { limit?: number; beforeId?: string },
) => {
  const query = new URLSearchParams();
  if (params?.limit) query.append('limit', String(params.limit));
  if (params?.beforeId) query.append('beforeId', params.beforeId);
  const qs = query.toString();
  return getNestedDataFetcher<TalkFlowChatMessage[]>(
    `${apiURL.TALK_FLOW_CHAT_MESSAGES(docId, sessionId)}${qs ? `?${qs}` : ''}`,
  );
};

// 회의록 공통 요약본(AI 요약) 재생성 요청 — 작성자 전용, aiPipelineId 반환
export const regenerateCommonSummary = (docId: string) =>
  postDataFetcher<Record<string, never>, { data: { aiPipelineId: string } }>(
    apiURL.TALK_FLOW_COMMON_SUMMARY_REGENERATE(docId),
    {},
  );

export const useAiSummeryStatus = (
  aiPipelineId: string,
  signal?: AbortSignal,
) =>
  getNestedDataFetcher<{
    id: string;
    status: string;
    createdAt: string;
    updatedAt: string;
  }>(
    apiURL.AI_PIPELINE_BY_ID(aiPipelineId),
    undefined,
    undefined,
    undefined,
    signal,
  );

export const useAiSummeryResult = (aiPipelineId: string) =>
  getNestedDataFetcher<{
    id: string;
    result: {
      summarize_text: string;
    };
    startedAt: string;
    endedAt: string;
    createdAt: string;
  }>(apiURL.AI_PIPELINE_RESULT_BY_ID(aiPipelineId));

export const createTalkFlow = (obj: CreateTalkFlowParams) =>
  postDataFetcher<
    CreateTalkFlowParams,
    { data: { talkFlowDocumentId: string } }
  >(apiURL.TALK_FLOW_DOCUMENT, obj);

export const modifyTalkFlow = (
  obj: CreateTalkFlowParams,
  talkFlowDocumentId: string,
) =>
  putDataFetcher<CreateTalkFlowParams>(
    apiURL.TALK_FLOW_DOCUMENT_BY_ID(talkFlowDocumentId),
    obj,
  );

export const useGetTalkFlowList = ({
  passportId,
  isOnlyShared,
}: {
  passportId?: string;
  isOnlyShared?: number;
}) =>
  useSWR<{ meta: Meta; data: RecordListType[] }>(
    `${
      apiURL.TALK_FLOW_DOCUMENT_LIST
    }?orderType=desc&sortType=createdAt&listSize=500${
      passportId ? `&createdBy=${passportId}` : ''
    }${isOnlyShared === 1 ? `&isOnlyShared=1` : ''}`,
    getNestedMetaDataFetcher,
  );

export const useGetNewTalkFlowList = (obj: DocumentListParams) => {
  const queryParam = buildQueryParams(obj);

  return useSWR<{ meta: Meta; data: RecordListType[] }>(
    `${apiURL.TALK_FLOW_DOCUMENT_LIST}?${queryParam}`,
    getNestedMetaDataFetcher,
  );
};

// 회의록 내용 가져오기
export const useTalkFlowDocument = (id?: string, config?: SWRConfiguration) =>
  useSWR<RecordDetail>(
    id ? apiURL.TALK_FLOW_DOCUMENT_BY_ID(id) : null,
    getNestedDataFetcher,
    config,
  );

// 회의록에 연결된 AI요약 내용 가져오기
export const useTalkFlowDocumentAiSummary = (
  payload: { documentId?: string; passportId: string },
  config?: SWRConfiguration,
) =>
  useSWR<TalkFlowAISummary[]>(
    payload.documentId
      ? apiURL.AI_PIPELINE_RESULT_DETAIL(payload.documentId, payload.passportId)
      : null,
    getNestedDataFetcher,
    config,
  );

export const deleteTalkFlowDocumentAiSummary = (
  documentId: string,
  aiPipelineId: string,
) => deleteDataFetcher(apiURL.AI_PIPELINE_REMOVE(documentId, aiPipelineId), {});

export const useGetTranslation = (obj: Translation) =>
  postDataFetcher<Translation, { data: string[] }>(AI_TRANSLATION_URL, obj);

export const deleteTalkFlowDocument = (id: string) =>
  deleteDataFetcher(apiURL.TALK_FLOW_DOCUMENT_BY_ID(id));

export const useTalkFlowRecordingDuration = () =>
  useSWR<{ duration: number }>(
    apiURL.TALK_FLOW_RECORDING_DURATION_LAST_30_DAYS,
    getNestedDataFetcher,
  );

export const useTalkFlowShareList = (id?: string) =>
  useSWR<{ meta: Meta; data: TalkFlowShare[] }>(
    id ? `${BASE_TALK_FLOW_URL}/acl/${id}?listSize=1000` : null,
    getNestedMetaDataFetcher,
  );

export type PopupBanner = {
  id: string;
  name: string;
  fileUrl: string;
  link?: string;
  linkTarget?: string;
};

export const useSetTalkFlowShareMode = (docId: string, org: ShareModeParam) =>
  postDataFetcher(`${BASE_TALK_FLOW_URL}/acl/${docId}/bulk`, org);

export const useChangeTalkFlowShareMode = (
  docId: string,
  obj: { role: string; roleId: string },
) => putDataFetcher(`${BASE_TALK_FLOW_URL}/acl/${docId}`, obj);

export const useDeleteTalkFlowShareMode = (docId: string, aclId: string) =>
  deleteDataFetcher(`${BASE_TALK_FLOW_URL}/acl/${docId}/${aclId}`);

export const usePopupList = (device: 'pc' | 'mobile') =>
  useSWR<PopupBanner[]>(
    `${POPUP_LIST}?displayDevice=${device}`,
    getNestedDataFetcher,
  );

export const dismissalPopup = (id: string) =>
  postDataFetcher(POPUP_DISMISSAL(id), {});

/**
 * 홈 이벤트 배너 조회. 노출할 배너만 노출 순서대로 최대 5건 내려온다.
 *
 * 노출 기간·노출 여부·노출 법인·화면 구분은 서버가 판정하므로 화면에서 다시 계산하지 않는다.
 * 대신 화면을 켜 둔 채로도 노출 시작/종료 시각이 반영되도록 주기적으로 다시 조회한다.
 */
export const useEventBanners = (displayDevice: EventBannerDisplayDevice) =>
  useSWR<EventBanner[]>(
    `${EVENT_BANNER_LIST}?displayDevice=${displayDevice}`,
    getNestedDataFetcher,
    { refreshInterval: EVENT_BANNER_REFRESH_INTERVAL },
  );

/**
 * 홈 TIP · 회의록 필터 영역 배너 조회. 요청 영역에 노출할 배너만 노출 순서대로 최대 5건 내려온다.
 * 이벤트 배너와 같은 주기로 다시 조회해 노출 시작/종료를 새로고침 없이 반영한다.
 */
export const useContentBanners = (area: ContentBannerArea) =>
  useSWR<ContentBanner[]>(
    `${CONTENT_BANNER_LIST}?area=${area}`,
    getNestedDataFetcher,
    { refreshInterval: EVENT_BANNER_REFRESH_INTERVAL },
  );

//TODO: 삭제하기
export const useQuitSmokingImages = () =>
  useSWR<{ uuid: string; createdAt: string; url: string }[]>(
    `/api/v1/event/230825/images?listSize=10000&currentPage=1&deleted=0&orderType=desc&sortType=created_at&eventType=fnf-nodam`,
    getNestedDataFetcher,
  );

export const useReadTalkFlow = (docId: string) =>
  postDataFetcher(`${BASE_TALK_FLOW_URL}/document/${docId}/read`, {});

const AIHost = process.env.NEXT_PUBLIC_AI_API_URL;
const AIToken = process.env.NEXT_PUBLIC_AI_API_AUTH ?? '';

const aiFetcher = <T = unknown>(u: string) =>
  getNestedMetaDataFetcher<T>(u, undefined, undefined, {
    Authorization: `Bearer ${AIToken}`,
  });

const aiPostFetcher = <Req, Res>(
  url: string,
  body: Req,
  signal?: AbortSignal,
) =>
  fetchApi<Res>({
    method: 'POST',
    url,
    data: body as any,
    extraHeaders: {
      Authorization: `Bearer ${AIToken}`,
    },
    signal,
  });

// useSWRImmutable 훅은 한 번만 데이터를 가져온다.
export const useGetAIMarketingParameter = () =>
  useSWRImmutable<AIMarketingParameterData>(
    AIHost + APPROVAL_MARKETING_AI_PARAMETERS,
    aiFetcher,
  );

export const usePostAIMarketingResult = (
  obj: SummaryParams,
  options?: { signal?: AbortSignal },
) =>
  aiPostFetcher<SummaryParams, SummaryResult>(
    AIHost + APPROVAL_MARKETING_AI_SUMMARY,
    obj,
    options?.signal,
  );

export const usePostAIMarketingAnalysis = (
  obj: AnalysisParams,
  options: { signal?: AbortSignal },
) =>
  aiPostFetcher<AnalysisParams, AnalysisResult>(
    AIHost + APPROVAL_MARKETING_AI_ANALYSIS,
    obj,
    options?.signal,
  );

export const usePostAIMarketingAnalysisApproval = (
  obj: AnalysisApprovalParams,
  options: { signal?: AbortSignal },
) =>
  postDataFetcher<AnalysisApprovalParams, AnalysisApprovalResult>(
    APPROVAL_MARKETING_ANALYSIS,
    obj,
    options?.signal,
  );

/**
 * 인테리어 공사비 적정성 보고서 결과 저장 (PORTAL-12794 / PORTAL-13040).
 * `storeId` 기준 upsert — 같은 매장을 여러 번 상신해도 문서는 1건으로 유지된다
 * (기존 문서를 갱신한 경우에도 201). **`storeId` 를 안 보내면 매번 새 문서가 생긴다.**
 */
export const usePostInteriorCostAdequacyApproval = (
  obj: InteriorCostAdequacyParams,
  options?: { signal?: AbortSignal },
) =>
  postDataFetcher<InteriorCostAdequacyParams, InteriorCostAdequacyResult>(
    APPROVAL_INTERIOR_COST_ADEQUACY,
    obj,
    options?.signal,
  );

/**
 * 인테리어 공사비 적정성 보고서 결과 갱신 (PORTAL-13042).
 * **부분 갱신** — 본문에 담은 필드만 바뀐다(품의 문서번호만 연결할 땐 `docId` 만).
 * 새 문서를 만들지 않으므로 id 를 들고 있는 동안은 이쪽이 정상 경로다.
 */
export const usePutInteriorCostAdequacyApproval = (
  reportId: string,
  obj: InteriorCostAdequacyParams,
) =>
  putDataFetcher<InteriorCostAdequacyParams, InteriorCostAdequacyResult>(
    `${APPROVAL_INTERIOR_COST_ADEQUACY}/${reportId}`,
    obj,
  );

/** 인테리어 공사비 적정성 보고서 → 결재 저장분 조회 (analysisId 없으면 목록) */
export const useGetInteriorCostAdequacyApproval = (analysisId?: string) =>
  getDataFetcher<Record<string, unknown>>(
    analysisId
      ? `${APPROVAL_INTERIOR_COST_ADEQUACY}/${analysisId}`
      : APPROVAL_INTERIOR_COST_ADEQUACY,
  );

/**
 * 인테리어 **정산 품의(234)** 결재 문서 저장 (PORTAL-14089) — 오픈 품의와 동일 계약의 정산 전용 리소스.
 * `storeId` 기준 upsert(매장당 정산 문서 1건). 오픈 문서(`interior-cost-adequacy`)와 완전히 독립이라
 * 같은 매장에 두 문서가 공존하고 서로 덮어쓰지 않는다. 오류 규약 = 403 타인 문서 · 404 없음 ·
 * 409 PUT 으로 타인 문서 매장 연결 · 422 매장 변경.
 */
export const usePostInteriorSettlementApproval = (
  obj: InteriorCostAdequacyParams,
  options?: { signal?: AbortSignal },
) =>
  postDataFetcher<InteriorCostAdequacyParams, InteriorCostAdequacyResult>(
    APPROVAL_INTERIOR_SETTLEMENT,
    obj,
    options?.signal,
  );

/** 정산 품의 문서 부분 갱신 — `result` 는 필드 통째 교체. 정산 경로로 오픈 문서를 고치려 하면 404. */
export const usePutInteriorSettlementApproval = (
  reportId: string,
  obj: InteriorCostAdequacyParams,
) =>
  putDataFetcher<InteriorCostAdequacyParams, InteriorCostAdequacyResult>(
    `${APPROVAL_INTERIOR_SETTLEMENT}/${reportId}`,
    obj,
  );

/** 정산 품의 문서 단건 조회 — 종류를 거르지 않는다(백필된 과거 정산 문서도 읽힌다). */
export const useGetInteriorSettlementApproval = (analysisId: string) =>
  getDataFetcher<Record<string, unknown>>(
    `${APPROVAL_INTERIOR_SETTLEMENT}/${analysisId}`,
  );

/**
 * 매장 기준 정산 문서 재열람 — `GET ?storeId=` → 0~1건. **storeId 는 필수**(전체 목록 없음).
 * 「정산 품의」 모달을 열 때만 호출해 편집분·첨부를 복원한다.
 */
export const useGetInteriorSettlementApprovalByStore = (storeId: string) =>
  getDataFetcher<{ data: Record<string, unknown>[] }>(
    `${APPROVAL_INTERIOR_SETTLEMENT}?storeId=${encodeURIComponent(storeId)}`,
  );

type AnyRow = Record<string, unknown>;

const DEFAULT_SKIP_KEYS = new Set(['Kstar', 'KstarText', 'type'] as const);

export function mergeBudgetRows<T extends AnyRow>(
  rows: T[],
  by: (r: T) => string,
  {
    skipKeys = DEFAULT_SKIP_KEYS, // 합산 제외 키
    numericKeys, // 지정 시 이 키들만 합산
  }: {
    skipKeys?: Set<string>;
    numericKeys?: (keyof T)[];
  } = {},
): T[] {
  const map = new Map<string, T>();
  const numericOnly = numericKeys?.map(String);

  for (const r of rows) {
    const key = by(r);
    const prev = map.get(key);

    if (!prev) {
      map.set(key, { ...r }); // 최초는 복사 저장
      continue;
    }

    // 누적: 숫자 필드만
    for (const [k, v] of Object.entries(r)) {
      if (skipKeys.has(k)) continue;
      if (numericOnly && !numericOnly.includes(k)) continue;

      const curr = toFiniteNumber(v);
      if (curr === null) continue;

      const prevNum = toFiniteNumber((prev as any)[k]) ?? 0;
      (prev as any)[k] = prevNum + curr;
    }
  }
  return [...map.values()];
}

export const useGetAIMarketingBudget = (
  costCenter: string | string[],
  season: string,
) => {
  const list = Array.isArray(costCenter)
    ? costCenter.filter(Boolean)
    : [costCenter].filter(Boolean);

  const shouldFetch = Boolean(list.length && season);

  // SWR 키에 전체 목록을 포함시켜 캐시 분리
  const key = shouldFetch ? ['AIMarketingBudget', season, ...list] : null;

  return useSWR<AIMarketingBudgetData[]>(key, async () => {
    const urls = list.map(
      (cc) =>
        `${MARKETING_BUDGET}` +
        `?costCenter=${encodeURIComponent(cc)}` +
        `&year=20${season.slice(0, 2)}` +
        `&season=${season.slice(2, 4)}`,
    );
    // 각 CC별 데이터 취득
    const chunks = await Promise.all(urls.map((u) => getNestedDataFetcher(u)));
    // 평탄화 후 KstarText 기준으로 숫자 필드 합산
    const merged = mergeBudgetRows(
      chunks.flat() as AIMarketingBudgetData[],
      (r) => (r as any).KstarText,
    );
    return merged;
  });
};

export const useGetAIMarketingPartners = (
  obj: venderType,
  shouldFetch: boolean,
) => {
  const newEntries = Object.entries(obj).filter(([k, v]) => !!v);
  const newObject = Object.fromEntries(newEntries) as Record<string, string>;
  const queryParam = new URLSearchParams(newObject);
  const url = `${MARKETING_PARTNER}?${queryParam}`;

  return useSWR<VenderListItem[]>(
    shouldFetch ? url : null,
    getNestedDataFetcher,
  );
};

export const useSetDocumentBookmarked = async (docId: string) =>
  await putDataFetcher(`${BASE_TALK_FLOW_URL}/document/${docId}/bookmark`, {});

export const useDeleteDocumentBookmarked = async (docId: string) =>
  await deleteDataFetcher(`${BASE_TALK_FLOW_URL}/document/${docId}/bookmark`);

export const useGetBrandSummary = ({
  season,
  brand,
  date,
  period,
  seasonBasis,
}: SalesParams) =>
  useSWR<BrandSummaryResponse>(
    `${SEASONS_URL}/${season}/brand/${brand}?date=${date}&period=${period}${seasonBasisQuery(
      seasonBasis,
    )}`,
    getNestedDataFetcher,
  );

export const useGetBrandInfo = (brandCode: string) =>
  useSWR<BrandMetaData>(
    `${SALES_URL}/brand/${brandCode}`,
    getNestedDataFetcher,
  );

export const useGetShopGroup = ({
  season,
  brand,
  date,
  period,
  seasonBasis,
}: SalesParams) =>
  useSWR<ShopGroup[]>(
    `${SEASONS_URL}/${season}/brand/${brand}/shop/group?date=${date}&period=${period}${seasonBasisQuery(
      seasonBasis,
    )}`,
    getNestedDataFetcher,
  );

export const useGetShopChannel = ({
  season,
  brand,
  date,
  period,
  seasonBasis,
}: SalesParams) =>
  useSWR<ShopGroup[]>(
    `${SEASONS_URL}/${season}/brand/${brand}/shop/channel?date=${date}&period=${period}${seasonBasisQuery(
      seasonBasis,
    )}`,
    getNestedDataFetcher,
  );

export const useGetShopRegion = ({
  season,
  brand,
  date,
  period,
  seasonBasis,
}: SalesParams) =>
  useSWR<ShopGroup[]>(
    `${SEASONS_URL}/${season}/brand/${brand}/shop/region?date=${date}&period=${period}${seasonBasisQuery(
      seasonBasis,
    )}`,
    getNestedDataFetcher,
  );

export const useGetShopGrade = ({
  season,
  brand,
  date,
  period,
  seasonBasis,
}: SalesParams) =>
  useSWR<ShopGroup[]>(
    `${SEASONS_URL}/${season}/brand/${brand}/shop/grade?date=${date}&period=${period}${seasonBasisQuery(
      seasonBasis,
    )}`,
    getNestedDataFetcher,
  );

export const useGetProductCategory = ({
  season,
  brand,
  date,
  period,
  seasonBasis,
}: SalesParams) =>
  useSWR<ProductCategory[]>(
    `${SEASONS_URL}/${season}/brand/${brand}/product/category?date=${date}&period=${period}${seasonBasisQuery(
      seasonBasis,
    )}`,
    getNestedDataFetcher,
  );

export const useGetProductSubCategory = ({
  season,
  brand,
  date,
  period,
  shopCode = 'ALL',
  seasonBasis,
}: SalesParams) => {
  const query = buildQueryParams({ date, period });
  return useSWR<ProductSubCategory[]>(
    `${SEASONS_URL}/${season}/brand/${brand}/shop/${shopCode}/product/subcategory?${query}${seasonBasisQuery(
      seasonBasis,
    )}`,
    getNestedDataFetcher,
  );
};

export const useGetCategoryFilters = ({ brand }: { brand: string }) =>
  useSWR<CategoryFilter>(
    `api/v1/sales/brand/${brand}/product/category/filters`,
    getNestedDataFetcher,
  );

// Talk Flow Favorite Filter APIs
export const useSetTalkFlowFavoriteFilter = (obj: DocumentFavoriteFilter) =>
  postDataFetcher(`${BASE_TALK_FLOW_URL}/favorite-filter`, obj);

export const useGetMyTalkFlowFavoriteFilter = () =>
  useSWR<FavoriteFilterData[]>(
    `${BASE_TALK_FLOW_URL}/favorite-filter/me?listSize=50`,
    getNestedDataFetcher,
  );

export const useDeleteTalkFlowFavoriteFilter = (id: string) =>
  deleteDataFetcher(`${BASE_TALK_FLOW_URL}/favorite-filter/${id}`);

export const useGetTalkFlowFavoriteFilter = (id?: string) =>
  useSWR<FavoriteFilterData>(
    id ? `${BASE_TALK_FLOW_URL}/favorite-filter/${id}` : null,
    getNestedDataFetcher,
  );

export const useModifyTalkFlowFavoriteFilter = ({
  id,
  name,
}: {
  id: string;
  name: string;
}) =>
  putDataFetcher(`${BASE_TALK_FLOW_URL}/favorite-filter/${id}/name`, {
    name,
  });

export const useGetSharedDocuments = () => {
  const { isMobilePath } = usePlatform();
  return useSWR<{ meta: Meta; data: RecordListType[] }>(
    `${apiURL.TALK_FLOW_DOCUMENT_LIST}?isRead=false&isOnlyShared=1`,
    getNestedMetaDataFetcher,
    {
      refreshInterval: isMobilePath ? 1000 : 0,
      shouldRetryOnError: false, // 에러 발생 시 재시도를 하지 않도록 설정
      revalidateOnFocus: false,
    },
  );
};

// Talk Flow - 최근 내부 참석자 목록 조회
export const useGetRecentTalkFlowAttendees = () =>
  useSWR<Passport[]>(
    `/api/v1/history/talk-flow/attendee/recently`,
    getNestedDataFetcher,
  );

// Talk Flow - 최근 검색한 내부 참석자 추가
export const addRecentTalkFlowAttendees = (passportIds: string[]) =>
  postDataFetcher('/api/v1/history/talk-flow/attendee/recently', {
    passportIds,
  });

// Talk Flow - 필터 추천(최근 작성자 / 내부 참석자) — 문서 목록 조회 시 이력이 자동 적립되며,
// 별도 저장 호출은 필요 없다
export const useGetTalkFlowFilterRecommend = () =>
  useSWR<{
    internalParticipants: TalkFlowFilterRecommendPerson[];
    createdBys: TalkFlowFilterRecommendPerson[];
  }>(`/api/v1/history/talk-flow/filter/recommend`, getNestedDataFetcher);

export const userGetPhoneBillStatus = (
  params: {
    year: number;
    month: number;
  } | null,
) =>
  useSWR<PhoneBillStatus>(
    params
      ? `/api/v1/expense-claims/telecom/me?year=${params.year}&month=${params.month}`
      : null,
    getNestedDataFetcher,
    {
      shouldRetryOnError: false, // 에러 발생 시 재시도를 하지 않도록 설정
      revalidateOnFocus: false,
    },
  );
export const userGetPhoneBillStatus2 = async (params: {
  year: number;
  month: number;
}) => {
  return await getNestedDataFetcher<PhoneBillStatus>(
    `/api/v1/expense-claims/telecom/me?year=${params.year}&month=${params.month}`,
  );
};

// F&CO 파일 분석 API
type FncoFileUploadItem = {
  fileUuid: string;
  mimeType: string;
};

type FncoAnalysisRequestBody = {
  files: FncoFileUploadItem[];
};

type FncoAnalysisAsyncResponse = {
  data: {
    id: string; // aiPipelineId
  };
};

type FncoAnalysisResultItem = {
  category: string;
  adType: string;
  vendor: string | null;
  amount: number;
  remark: string | null;
};

type FncoAnalysisMetadata = {
  items: FncoAnalysisResultItem[];
  companyName: string;
};

type FncoAnalysisStatusResponse = {
  data: {
    id: string;
    status: string;
    result:
      | {
          metadata: FncoAnalysisMetadata[];
        }[]
      | null;
  };
};

export type FncoFileBudgetItem = {
  id: string;
  category: string;
  adType: string;
  landingMedia: string;
  amount: number;
};

// 1. 파일 업로드 후 UUID 받기
const uploadFncoFiles = async (
  files: File[],
  signal?: AbortSignal,
): Promise<FncoFileUploadItem[]> => {
  const uploadPromises = files.map(async (file) => {
    const uploadResponse = await useUploadFile(file, false, signal);
    return {
      fileUuid: uploadResponse.data.uuid,
      mimeType: file.type,
    };
  });

  return await Promise.all(uploadPromises);
};

// 2. AI 분석 비동기 요청
const requestFncoAnalysis = async (
  fileItems: FncoFileUploadItem[],
  signal?: AbortSignal,
): Promise<string> => {
  const response = await fetchApi<FncoAnalysisAsyncResponse>({
    method: 'POST',
    url: '/api/v1/approval/ai/fnco-mkt-advance/async',
    data: {
      files: fileItems,
    },
    signal,
  });

  return response.data.id;
};

// 3. AI 분석 상태 폴링
const pollFncoAnalysisStatus = async (
  aiPipelineId: string,
  signal?: AbortSignal,
  maxRetries = 300, // 최대 300초 (5분)
  interval = 1000, // 1초마다 폴링
): Promise<FncoAnalysisResultItem[]> => {
  let retries = 0;

  while (retries < maxRetries) {
    if (signal?.aborted) {
      throw new Error('AbortError');
    }

    const response = await fetchApi<FncoAnalysisStatusResponse>({
      method: 'GET',
      url: `/api/v1/approval/ai/async/${aiPipelineId}`,
      signal,
    });

    // status가 "done"이면 완료된 것
    if (response.data.status === 'done') {
      if (
        !response.data.result ||
        !Array.isArray(response.data.result) ||
        response.data.result.length === 0 ||
        !response.data.result[0] ||
        !response.data.result[0].metadata ||
        !Array.isArray(response.data.result[0].metadata) ||
        response.data.result[0].metadata.length === 0
      ) {
        // done이지만 데이터가 없으면 빈 배열 반환
        return [];
      }

      // metadata 배열의 모든 items를 평탄화 (모든 company)
      const allItems = response.data.result[0].metadata.flatMap(
        (meta) => meta.items,
      );

      return allItems;
    }

    retries++;
    await new Promise((resolve) => setTimeout(resolve, interval));
  }

  throw new Error('File analysis timeout');
};

// 전체 파일 분석 프로세스
export const analyzeFncoFiles = async (
  files: File[],
  options: {
    categoryOptions: { title: string; value: string }[];
    adTypeOptions: { title: string; value: string }[];
    landingMediaOptions: { title: string; value: string }[];
  },
  signal?: AbortSignal,
): Promise<FncoFileBudgetItem[]> => {
  // 1. 파일 업로드
  const uploadedFiles = await uploadFncoFiles(files, signal);

  // 2. AI 분석 요청
  const aiPipelineId = await requestFncoAnalysis(uploadedFiles, signal);

  // 3. 결과 폴링
  const analysisResults = await pollFncoAnalysisStatus(aiPipelineId, signal);

  // 옵션 title -> value 매핑 생성
  const categoryMap = new Map(
    options.categoryOptions.map((o) => [o.title, o.value]),
  );
  const adTypeMap = new Map(
    options.adTypeOptions.map((o) => [o.title, o.value]),
  );
  const landingMediaMap = new Map(
    options.landingMediaOptions.map((o) => [o.title, o.value]),
  );

  // 4. 결과 변환 및 검증
  return analysisResults.map((item) => ({
    id: crypto.randomUUID?.() || `${Date.now()}-${Math.random()}`,
    category: item.category ? categoryMap.get(item.category) || '' : '',
    adType: item.adType ? adTypeMap.get(item.adType) || '' : '',
    landingMedia: item.vendor ? landingMediaMap.get(item.vendor) || '' : '',
    amount: item.amount || 0,
  }));
};
